const contentMediaAssets = [];

const contentMediaApi = {
  adminList: {
    method: 'GET',
    path: '/api/yowan/admin/content/media/',
    buildQuery: (usageScope) => ({
      usage_scope: usageScope,
    }),
  },
  adminCreate: {
    method: 'POST',
    path: '/api/yowan/admin/content/media/create/',
    requestType: 'multipart/form-data',
  },
  adminDetail: {
    method: 'GET',
    path: '/api/yowan/admin/content/media/<id>/',
  },
  adminUpdate: {
    method: 'POST',
    path: '/api/yowan/admin/content/media/<id>/update/',
    requestType: 'multipart/form-data',
  },
  adminDeactivate: {
    method: 'POST',
    path: '/api/yowan/admin/content/media/<id>/deactivate/',
  },
};

const normalizeContentMediaAsset = (asset = {}) => ({
  id: asset.id || '',
  url: asset.url || '',
  thumbnail_url: asset.thumbnail_url || asset.url || '',
  preview_url: asset.preview_url || asset.thumbnail_url || asset.url || '',
  alt_text: asset.alt_text || '',
  caption: asset.caption || '',
  usage_scope: asset.usage_scope || 'shared',
  is_active: asset.is_active !== false,
});

const normalizeContentMediaAssetList = (payload) => {
  const rawAssets = Array.isArray(payload?.results)
    ? payload.results
    : Array.isArray(payload)
      ? payload
      : [];

  return rawAssets.map(normalizeContentMediaAsset);
};

const getContentMediaAssetOptions = ({
  usageScope,
  currentAssetId = '',
  sourceAssets = contentMediaAssets,
}) => {
  return sourceAssets
    .filter((asset) => {
      if (asset.id === currentAssetId) {
        return true;
      }

      return asset.is_active && (asset.usage_scope === usageScope || asset.usage_scope === 'shared');
    })
    .map((asset) => ({
      value: asset.id,
      label: `${asset.caption} / ${asset.usage_scope}`,
      description: asset.alt_text,
      isActive: asset.is_active,
    }));
};

const createPrimaryImageField = (usageScope, currentAssetId = '') => ({
  name: 'primary_image_id',
  readName: 'primary_image',
  usageScope,
  api: Object.assign({}, contentMediaApi.adminList, {
    query: contentMediaApi.adminList.buildQuery(usageScope),
    normalizeResponse: normalizeContentMediaAssetList,
  }),
  fallbackAssets: contentMediaAssets,
  options: getContentMediaAssetOptions({ usageScope, currentAssetId }),
  helpText: '新しい画像を選ぶと、保存時にこのコンテンツの画像として使用します。',
});

const blogEntries = [];

const blogDetailPages = {};
const adminBlogRows = [];
const adminBlogDetailRecords = {};

const yowanPersonLedgerDefaults = {
  personId: '',
  personDisplayName: '',
  personNameKana: '',
  personEmail: '',
  personPhone: '',
  personOrganization: '',
  personRoleTitle: '',
  personInternalNote: '',
  personIsActive: true,
};

const yowanPersonLedgerFormContent = {
  title: '人物台帳',
  lead: '会員プロフィールや公開プロフィールとは別に、運営が関係者として把握するための内部記録です。招待メールなどの宛名に使う場合がありますが、公開面、SEO、権限判定には使用しません。',
  labels: {
    personId: '既存人物台帳',
    displayName: 'お名前',
    nameKana: 'ふりがな',
    email: 'メールアドレス',
    phone: '電話番号',
    organization: '所属・団体',
    roleTitle: '肩書き',
    internalNote: '管理メモ',
    isActive: '人物台帳を有効にする',
  },
  noPersonOptionLabel: '紐づけなし',
  personSelectHelpText: '既存人物台帳を選ぶと、この役割プロフィールと内部人物台帳を明示的に紐づけます。メールアドレスの一致だけで自動統合はしません。',
  memberBoundaryHelpText: '会員プロフィールとは独立した内部記録です。双方の情報は自動同期されません。',
  sharedHelpText: 'この人物台帳は他の役割にも紐づいています。内部人物情報の変更は共有されます。',
  noUsageText: 'この人物台帳は、保存後に役割との紐づきとして記録されます。',
  loadingText: '人物台帳の選択肢を読み込んでいます。',
};

const adminNewsRows = [];
const adminNewsDetailRecords = {};

const adminReviewRows = [];

const adminReviewDetailRecords = Object.fromEntries(
  adminReviewRows.map((row) => [
    row.id,
    {
      id: row.id,
      title: row.title,
      body: row.body,
      displayOrder: row.displayOrder,
      isPublished: row.isPublished,
      createdAt: row.createdAt,
      updatedAt: row.updatedAt,
    },
  ]),
);

const adminFounderCassetteRows = [];

const adminFounderCassetteRecords = Object.fromEntries(
  adminFounderCassetteRows.map((row) => [
    row.id,
    {
      id: row.id,
      pageKey: 'founder',
      title: row.title,
      body: row.body,
      displayOrder: row.displayOrder,
      isPublished: row.isPublished,
      primary_image_id: row.primary_image_id,
      primary_image: row.primary_image,
      createdAt: row.createdAt,
      updatedAt: row.updatedAt,
    },
  ]),
);

const adminMemberRows = [
  {
    id: '40000000-0000-0000-0000-000000000001',
    name: '山田 太郎',
    email: 'member1@example.com',
    phone: '090-1111-1111',
    postalCode: '100-0001',
    address: '東京都千代田区丸の内 1-1-1',
    note: '手動登録された会員プロフィールです。',
    profileJson: '{\n  "source": "manual"\n}',
    lifecycleStatus: 'active',
    isActive: true,
    memberAccessLabel: '一般会員 / 講師 / 主催者',
    operatorAccessLabel: '指導者',
    createdAt: '2026-04-20 10:00',
    updatedAt: '2026-04-21 10:00',
    editHref: '/admin/members/40000000-0000-0000-0000-000000000001/edit',
  },
  {
    id: '40000000-0000-0000-0000-000000000002',
    name: '佐藤 花子',
    email: 'member2@example.com',
    phone: '080-2222-2222',
    postalCode: '150-0001',
    address: '東京都渋谷区神宮前 2-2-2',
    note: '休会中の会員プロフィールです。',
    profileJson: '{\n  "source": "import"\n}',
    lifecycleStatus: 'suspended',
    isActive: false,
    memberAccessLabel: '休会',
    operatorAccessLabel: 'なし',
    createdAt: '2026-04-18 09:30',
    updatedAt: '2026-04-20 12:00',
    editHref: '/admin/members/40000000-0000-0000-0000-000000000002/edit',
  },
  {
    id: '40000000-0000-0000-0000-000000000003',
    name: '鈴木 次郎',
    email: 'member3@example.com',
    phone: '070-3333-3333',
    postalCode: '530-0001',
    address: '大阪府大阪市北区梅田 3-3-3',
    note: '退会済みの会員プロフィールです。',
    profileJson: '{\n  "source": "promotion"\n}',
    lifecycleStatus: 'withdrawn',
    isActive: false,
    memberAccessLabel: '会主宰者 / 講師 / 主催者',
    operatorAccessLabel: '管理者',
    createdAt: '2026-04-15 14:20',
    updatedAt: '2026-04-19 16:30',
    editHref: '/admin/members/40000000-0000-0000-0000-000000000003/edit',
  },
];

const adminMemberDetailRecords = Object.fromEntries(
  adminMemberRows.map((row) => [
    row.id,
    {
      id: row.id,
      name: row.name,
      email: row.email,
      phone: row.phone,
      postalCode: row.postalCode,
      address: row.address,
      note: row.note,
      profileJson: row.profileJson,
      lifecycleStatus: row.lifecycleStatus,
      isActive: row.isActive,
      memberAccessLabel: row.memberAccessLabel,
      operatorAccessLabel: row.operatorAccessLabel,
      createdAt: row.createdAt,
      updatedAt: row.updatedAt,
    },
  ]),
);

const adminAccessMemberOptions = [
  { value: '', label: '対象会員を選択' },
];

const adminFacilityRows = [
  {
    id: 'facility-tokyo-waseda',
    facilityName: '東京 西早稲田施設',
    shortName: '西早稲田',
    address: '東京都新宿区西早稲田 1-1-1',
    phone: '03-0000-0000',
    gmap: 'https://maps.example.com/tokyo-waseda',
    url: 'https://example.com/facilities/tokyo-waseda',
    image: 'https://example.com/yowan/facilities/tokyo-waseda.jpg',
    isActive: true,
    roomCount: 2,
    remarks: '東京教室と単発セミナーの主会場として扱う想定です。',
    updatedAt: '2026-04-20 10:00',
    editHref: '/admin/events/facilities/facility-tokyo-waseda/edit',
  },
  {
    id: 'facility-sapporo-center',
    facilityName: '札幌 中央施設',
    shortName: '札幌中央',
    address: '北海道札幌市中央区北1条西 1-1-1',
    phone: '011-000-0000',
    gmap: 'https://maps.example.com/sapporo-center',
    url: 'https://example.com/facilities/sapporo-center',
    image: 'https://example.com/yowan/facilities/sapporo-center.jpg',
    isActive: true,
    roomCount: 1,
    remarks: '札幌開催のセミナー会場として利用する想定です。',
    updatedAt: '2026-04-19 11:20',
    editHref: '/admin/events/facilities/facility-sapporo-center/edit',
  },
  {
    id: 'facility-kyoto-studio',
    facilityName: '京都 稽古場',
    shortName: '京都',
    address: '京都府京都市中京区 1-1-1',
    phone: '075-000-0000',
    gmap: 'https://maps.example.com/kyoto-studio',
    url: 'https://example.com/facilities/kyoto-studio',
    image: 'https://example.com/yowan/facilities/kyoto-studio.jpg',
    isActive: false,
    roomCount: 1,
    remarks: '利用再開時に有効化する候補施設です。',
    updatedAt: '2026-04-18 09:45',
    editHref: '/admin/events/facilities/facility-kyoto-studio/edit',
  },
];

const adminRoomRows = [
  {
    id: 'room-tokyo-a',
    roomName: '第1教室',
    facilityId: 'facility-tokyo-waseda',
    facilityName: '東京 西早稲田施設',
    capacity: 20,
    isActive: true,
    remarks: '教室と小規模セミナーの標準部屋です。',
    updatedAt: '2026-04-20 10:10',
    editHref: '/admin/events/rooms/room-tokyo-a/edit',
  },
  {
    id: 'room-tokyo-b',
    roomName: '第2教室',
    facilityId: 'facility-tokyo-waseda',
    facilityName: '東京 西早稲田施設',
    capacity: 12,
    isActive: true,
    remarks: '個別講座や少人数枠の候補部屋です。',
    updatedAt: '2026-04-19 14:30',
    editHref: '/admin/events/rooms/room-tokyo-b/edit',
  },
  {
    id: 'room-sapporo-a',
    roomName: '第1教室',
    facilityId: 'facility-sapporo-center',
    facilityName: '札幌 中央施設',
    capacity: 18,
    isActive: true,
    remarks: '札幌セミナーの候補部屋です。',
    updatedAt: '2026-04-19 11:35',
    editHref: '/admin/events/rooms/room-sapporo-a/edit',
  },
  {
    id: 'room-kyoto-main',
    roomName: '主室',
    facilityId: 'facility-kyoto-studio',
    facilityName: '京都 稽古場',
    capacity: 16,
    isActive: false,
    remarks: '施設再開後に使用する想定です。',
    updatedAt: '2026-04-18 10:00',
    editHref: '/admin/events/rooms/room-kyoto-main/edit',
  },
];

const getAdminRoomsForFacility = (facilityId) =>
  adminRoomRows
    .filter((room) => room.facilityId === facilityId)
    .map((room) => ({
      roomName: room.roomName,
      capacity: room.capacity,
      isActive: room.isActive,
      remarks: room.remarks,
    }));

const adminFacilityDetailRecords = Object.fromEntries(
  adminFacilityRows.map((row) => [
    row.id,
    Object.assign({}, row, {
      rooms: getAdminRoomsForFacility(row.id),
    }),
  ]),
);

const adminRoomDetailRecords = Object.fromEntries(
  adminRoomRows.map((row) => [row.id, row]),
);

const adminFacilityOptions = [
  { value: '', label: '未選択' },
];

const adminRoomOptions = [
  { value: '', label: '未選択' },
];

const adminLocationDisplayModeOptions = [
  { value: 'facility', label: '施設・部屋を公開' },
  { value: 'facility_public_label', label: '施設の公開用表示' },
  { value: 'area_only', label: 'エリアのみ公開' },
  { value: 'after_application', label: '申込後に案内' },
  { value: 'undecided', label: '会場未定' },
  { value: 'custom', label: '任意表示' },
];

const adminClassLocationDisplayModeOptions = [
  { value: 'true', label: '公開する' },
  { value: 'false', label: '公開しない' },
];

const adminScheduleKindOptions = [
  { value: 'weekly', label: '毎週' },
  { value: 'biweekly', label: '隔週' },
  { value: 'monthly_nth', label: '毎月第n曜日' },
  { value: 'irregular', label: '不定期' },
  { value: 'custom', label: '任意表示' },
];

const adminInstructorRows = [
  {
    id: '92000000-0000-0000-0000-000000000001',
    instructorName: '山田 太郎',
    memberId: '40000000-0000-0000-0000-000000000001',
    memberName: '山田 太郎',
    memberEmail: 'member1@example.com',
    instructorEmail: 'instructor-yamada@example.com',
    personalUrl: 'https://example.com/instructors/yamada',
    webLinks: [
      { platformKey: 'website', label: '公式サイト', url: 'https://example.com/instructors/yamada', displayOrder: 10, isActive: true },
      { platformKey: 'facebook', label: 'Facebook', url: 'https://example.com/facebook/yamada', displayOrder: 20, isActive: true },
    ],
    roleLabel: '揺腕公認インストラクター',
    biography: '揺腕法の基本講座と東京教室を担当する講師プロフィールです。',
    career: '稽古歴・指導歴の概要が入ります。',
    image: 'https://example.com/yowan/instructors/yamada.jpg',
    specialties: '基礎講座 / 東京教室',
    isActive: true,
    publicProfileEnabled: true,
    remarks: '会員と紐づく通常講師です。',
    updatedAt: '2026-04-21 10:00',
    editHref: '/admin/events/instructors/92000000-0000-0000-0000-000000000001/edit',
  },
  {
    id: '92000000-0000-0000-0000-000000000002',
    instructorName: '補助講師名',
    memberId: '40000000-0000-0000-0000-000000000003',
    memberName: '鈴木 次郎',
    memberEmail: 'member3@example.com',
    instructorEmail: 'assistant-instructor@example.com',
    personalUrl: '',
    webLinks: [],
    roleLabel: '直伝指導補助',
    biography: 'セミナーの補助講師として表示するプロフィールです。',
    career: '補助講師としての経歴概要が入ります。',
    image: '',
    specialties: 'セミナー補助 / 札幌',
    isActive: true,
    publicProfileEnabled: false,
    remarks: '公開プロフィールは未公開です。',
    updatedAt: '2026-04-20 13:20',
    editHref: '/admin/events/instructors/92000000-0000-0000-0000-000000000002/edit',
  },
  {
    id: '92000000-0000-0000-0000-000000000003',
    instructorName: '外部講師 佐伯',
    memberId: '',
    memberName: '',
    memberEmail: '',
    instructorEmail: 'external-instructor@example.com',
    personalUrl: 'https://example.com/external-instructor',
    webLinks: [
      { platformKey: 'website', label: '公式サイト', url: 'https://example.com/external-instructor', displayOrder: 10, isActive: true },
    ],
    roleLabel: '外部講師',
    biography: '会員に紐づいていない外部講師プロフィールです。',
    career: '外部講師の経歴概要が入ります。',
    image: '',
    specialties: '特別講座',
    isActive: false,
    publicProfileEnabled: false,
    remarks: '会員に紐づいていない外部講師です。',
    updatedAt: '2026-04-18 09:30',
    editHref: '/admin/events/instructors/92000000-0000-0000-0000-000000000003/edit',
  },
];

const adminInstructorDetailRecords = Object.fromEntries(
  adminInstructorRows.map((row) => [
    row.id,
    {
      id: row.id,
      instructorName: row.instructorName,
      memberId: row.memberId,
      memberName: row.memberName,
      memberEmail: row.memberEmail,
      instructorEmail: row.instructorEmail,
      personalUrl: row.personalUrl,
      webLinks: row.webLinks || [],
      webLinkWebsite: row.webLinks?.find((link) => link.platformKey === 'website')?.url || row.personalUrl || '',
      webLinkFacebook: row.webLinks?.find((link) => link.platformKey === 'facebook')?.url || '',
      webLinkX: row.webLinks?.find((link) => link.platformKey === 'x')?.url || '',
      webLinkInstagram: row.webLinks?.find((link) => link.platformKey === 'instagram')?.url || '',
      webLinkYoutube: row.webLinks?.find((link) => link.platformKey === 'youtube')?.url || '',
      webLinkTiktok: row.webLinks?.find((link) => link.platformKey === 'tiktok')?.url || '',
      webLinkOther: row.webLinks?.find((link) => link.platformKey === 'other')?.url || '',
      roleLabel: row.roleLabel,
      biography: row.biography,
      career: row.career,
      image: row.image,
      specialties: row.specialties,
      isActive: row.isActive,
      publicProfileEnabled: row.publicProfileEnabled,
      remarks: row.remarks,
      updatedAt: row.updatedAt,
    },
  ]),
);

const adminInstructorMemberOptions = [
  { value: '', label: '未紐づき / 外部講師' },
];

const adminInstructorOptions = [
  { value: '', label: '講師を選択' },
];

const adminOrganizerRows = [
  {
    id: '93000000-0000-0000-0000-000000000001',
    organizerName: '東京教室運営',
    organizerType: 'individual',
    organizerTypeLabel: '個人',
    memberId: '40000000-0000-0000-0000-000000000001',
    memberName: '山田 太郎',
    memberEmail: 'member1@example.com',
    representativeName: '山田 太郎',
    contactEmail: 'tokyo-organizer@example.com',
    contactPhone: '03-1111-1111',
    websiteUrl: 'https://example.com/yowan/tokyo',
    image: '',
    description: '東京教室の開催責任主体です。',
    publicProfileEnabled: true,
    isActive: true,
    remarks: '会員と紐づく主宰者です。',
    updatedAt: '2026-04-22 09:00',
    editHref: '/admin/events/organizers/93000000-0000-0000-0000-000000000001/edit',
  },
  {
    id: '93000000-0000-0000-0000-000000000002',
    organizerName: '札幌セミナー実行委員会',
    organizerType: 'group',
    organizerTypeLabel: '団体',
    memberId: '',
    memberName: '',
    memberEmail: '',
    representativeName: '札幌 代表',
    contactEmail: 'sapporo-organizer@example.com',
    contactPhone: '011-111-1111',
    websiteUrl: 'https://example.com/yowan/sapporo',
    image: '',
    description: '札幌セミナーを主催する団体です。',
    publicProfileEnabled: false,
    isActive: true,
    remarks: '外部団体の主催者です。',
    updatedAt: '2026-04-21 14:00',
    editHref: '/admin/events/organizers/93000000-0000-0000-0000-000000000002/edit',
  },
  {
    id: '93000000-0000-0000-0000-000000000003',
    organizerName: '外部主催者 佐伯',
    organizerType: 'individual',
    organizerTypeLabel: '個人',
    memberId: '',
    memberName: '',
    memberEmail: '',
    representativeName: '外部 主催',
    contactEmail: 'external-organizer@example.com',
    contactPhone: '',
    websiteUrl: '',
    image: '',
    description: '外部主催者のプロフィールです。',
    publicProfileEnabled: false,
    isActive: false,
    remarks: '会員に紐づいていない主催者です。',
    updatedAt: '2026-04-19 12:00',
    editHref: '/admin/events/organizers/93000000-0000-0000-0000-000000000003/edit',
  },
];

const adminOrganizerDetailRecords = Object.fromEntries(
  adminOrganizerRows.map((row) => [row.id, row]),
);

const adminOrganizerMemberOptions = [
  { value: '', label: '未紐づき / 外部主催者' },
];

const adminOrganizerOptions = [
  { value: '', label: '主催者を選択' },
];

const adminNotificationRows = [
  {
    id: '97000000-0000-0000-0000-000000000001',
    categoryLabel: '申込',
    eventLabel: 'セミナー申込受付',
    eventKey: 'event.application_created',
    status: 'sent',
    statusLabel: '送信済み',
    channelLabel: 'メール',
    deliveryModeLabel: '自動返信 / 管理者通知',
    templateKey: 'event_application_created',
    subject: '札幌セミナーのお申し込みを受け付けました',
    recipientSummary: 'applicant1@example.com / operator-admin',
    sourceLabel: '札幌セミナー',
    sourceKind: 'event_application',
    triggerPoint: '申込受付',
    processedAt: '2026-04-21 11:30',
    detailHref: '/admin/notifications/97000000-0000-0000-0000-000000000001',
    renderedBody:
      '札幌セミナーへのお申し込みを受け付けました。\n\n開催日時と参加費、当日の持ち物をご確認ください。',
    resolvedRecipientsJson: JSON.stringify(
      {
        to: ['applicant1@example.com'],
        bcc: ['operator@example.com'],
      },
      null,
      2,
    ),
    triggerContextJson: JSON.stringify(
      {
        event_id: '90000000-0000-0000-0000-000000000003',
        application_id: 'application-001',
        source_label: '札幌セミナー',
      },
      null,
      2,
    ),
    lastErrorMessage: '',
  },
  {
    id: '97000000-0000-0000-0000-000000000002',
    categoryLabel: '問合せ',
    eventLabel: '問い合わせ・申込者作成通知',
    eventKey: 'applicant.created',
    status: 'sent',
    statusLabel: '送信済み',
    channelLabel: 'メール',
    deliveryModeLabel: '管理者通知',
    templateKey: 'applicant_created_admin',
    subject: '新しいお問い合わせが届きました',
    recipientSummary: 'operator-admin',
    sourceLabel: '一般問合せ',
    sourceKind: 'applicant',
    triggerPoint: '問い合わせ・申込者作成',
    processedAt: '2026-04-21 09:45',
    detailHref: '/admin/notifications/97000000-0000-0000-0000-000000000002',
    renderedBody:
      '新しいお問い合わせが届きました。\n\n問い合わせ・申込者一覧から対象者と問合せ内容を確認してください。',
    resolvedRecipientsJson: JSON.stringify(
      {
        to: ['operator@example.com'],
      },
      null,
      2,
    ),
    triggerContextJson: JSON.stringify(
      {
        applicant_id: '30000000-0000-0000-0000-000000000002',
        source_kind: 'general_inquiry',
        source_label: '一般問合せ',
      },
      null,
      2,
    ),
    lastErrorMessage: '',
  },
  {
    id: '97000000-0000-0000-0000-000000000003',
    categoryLabel: 'セミナー連絡',
    eventLabel: '参加者メール送信',
    eventKey: 'event.application_mail_sent',
    status: 'queued',
    statusLabel: '送信待ち',
    channelLabel: 'メール',
    deliveryModeLabel: '手動送信',
    templateKey: 'operator_event_application_mail',
    subject: '当日のご案内',
    recipientSummary: '参加者全員 2名',
    sourceLabel: '京都セミナー',
    sourceKind: 'event_application_mail',
    triggerPoint: '管理者メール作成',
    processedAt: '2026-04-20 16:20',
    detailHref: '/admin/notifications/97000000-0000-0000-0000-000000000003',
    renderedBody:
      '京都セミナーへお申し込みいただきありがとうございます。\n\n当日の受付時間と会場入口についてご案内します。',
    resolvedRecipientsJson: JSON.stringify(
      {
        to: ['participant1@example.com', 'participant2@example.com'],
      },
      null,
      2,
    ),
    triggerContextJson: JSON.stringify(
      {
        event_id: '90000000-0000-0000-0000-000000000004',
        audience_mode: 'all',
      },
      null,
      2,
    ),
    lastErrorMessage: '',
  },
  {
    id: '97000000-0000-0000-0000-000000000004',
    categoryLabel: 'コンテンツ通知',
    eventLabel: 'お知らせ公開通知',
    eventKey: 'content.news_published',
    status: 'failed',
    statusLabel: '失敗',
    channelLabel: 'メール',
    deliveryModeLabel: '自動通知',
    templateKey: 'content_news_published_default',
    subject: '新しいお知らせを公開しました',
    recipientSummary: '有効会員セグメント',
    sourceLabel: 'お知らせ',
    sourceKind: 'content_news',
    triggerPoint: 'お知らせ公開',
    processedAt: '2026-04-19 18:05',
    detailHref: '/admin/notifications/97000000-0000-0000-0000-000000000004',
    renderedBody:
      '新しいお知らせを公開しました。\n\n詳細は公開ページをご確認ください。',
    resolvedRecipientsJson: JSON.stringify(
      {
        segment: 'yowan_news_recipients',
        resolved_count: 0,
      },
      null,
      2,
    ),
    triggerContextJson: JSON.stringify(
      {
        news_id: '10000000-0000-0000-0000-000000000001',
      },
      null,
      2,
    ),
    lastErrorMessage: '宛先の解決結果が空でした',
  },
  {
    id: '97000000-0000-0000-0000-000000000005',
    categoryLabel: '認証',
    eventLabel: 'パスワード再設定',
    eventKey: 'auth.password_reset_requested',
    status: 'sent',
    statusLabel: '送信済み',
    channelLabel: 'メール',
    deliveryModeLabel: '自動返信',
    templateKey: 'auth_password_reset_requested',
    subject: 'パスワード再設定のご案内',
    recipientSummary: 'member1@example.com',
    sourceLabel: 'パスワード再設定',
    sourceKind: 'auth',
    triggerPoint: 'パスワード再設定リクエスト受付',
    processedAt: '2026-04-18 08:10',
    detailHref: '/admin/notifications/97000000-0000-0000-0000-000000000005',
    renderedBody:
      'パスワード再設定のリクエストを受け付けました。\n\n以下のリンクから再設定を行ってください。',
    resolvedRecipientsJson: JSON.stringify(
      {
        to: ['member1@example.com'],
      },
      null,
      2,
    ),
    triggerContextJson: JSON.stringify(
      {
        account_ref: 'account-sample',
      },
      null,
      2,
    ),
    lastErrorMessage: '',
  },
];

const adminNotificationDetailRecords = Object.fromEntries(
  adminNotificationRows.map((row) => [row.id, row]),
);

const adminEventRows = [
  {
    id: '90000000-0000-0000-0000-000000000001',
    title: '東京教室',
    guidance: '東京教室の開催案内が入ります。',
    summary: '毎週開催の常設クラスです。',
    eventType: 'regular',
    eventTypeLabel: '常設クラス',
    organizerId: '93000000-0000-0000-0000-000000000001',
    organizerName: '東京教室運営',
    scheduleRuleJson: '{\n  "kind": "weekly",\n  "weekday": "tuesday",\n  "start_time": "18:50",\n  "end_time": "20:00"\n}',
    image: 'https://example.com/yowan/tokyo-class.jpg',
    standardStartAt: '18:50',
    standardEndAt: '20:00',
    weekday: 'tuesday',
    standardFacilityId: 'facility-tokyo-waseda',
    standardRoomId: 'room-tokyo-a',
    standardAddress: '東京都新宿区西早稲田 1-1-1',
    standardRoomName: '東京教室 第1教室',
    standardCapacity: 20,
    standardSlotFee: 3000,
    standardInstructorId: '92000000-0000-0000-0000-000000000001',
    standardInstructor: '山田 太郎',
    isPublished: true,
    isActive: true,
    slotsCount: 4,
    applicationsCount: 12,
    nextSlotLabel: '2026-05-12 18:50',
    updatedAt: '2026-04-21 10:00',
    editHref: '/admin/events/90000000-0000-0000-0000-000000000001/edit',
    slotsHref: '/admin/events/90000000-0000-0000-0000-000000000001/edit#slots',
    applicationsHref: '/admin/events/90000000-0000-0000-0000-000000000001/applications',
  },
  {
    id: '90000000-0000-0000-0000-000000000002',
    title: '札幌セミナー',
    guidance: '札幌セミナーの開催案内が入ります。',
    summary: '単発セミナーです。',
    eventType: 'spot',
    eventTypeLabel: '単発セミナー',
    organizerId: '93000000-0000-0000-0000-000000000002',
    organizerName: '札幌セミナー実行委員会',
    scheduleRuleJson: '{\n  "kind": "single"\n}',
    image: 'https://example.com/yowan/sapporo-seminar.jpg',
    standardInstructor: '山田 太郎 / 補助講師名',
    slots: [
      {
        startAt: '2026-06-20T13:00',
        endAt: '2026-06-20T16:00',
        facilityId: 'facility-sapporo-center',
        roomId: 'room-sapporo-a',
        address: '北海道札幌市中央区北1条西 1-1-1',
        roomName: '札幌会場 第1教室',
        capacity: 24,
        slotFee: 8000,
        instructorId: '92000000-0000-0000-0000-000000000001',
        instructor: '山田 太郎',
        isOpen: true,
        isActive: true,
        applicationsCount: 2,
      },
      {
        startAt: '2026-06-21T10:00',
        endAt: '2026-06-21T12:00',
        facilityId: 'facility-sapporo-center',
        roomId: 'room-sapporo-a',
        capacity: 18,
        slotFee: 6000,
        instructorId: '92000000-0000-0000-0000-000000000002',
        instructor: '補助講師名',
        isOpen: true,
        isActive: true,
        applicationsCount: 1,
      },
    ],
    isPublished: true,
    isActive: true,
    slotsCount: 2,
    applicationsCount: 3,
    nextSlotLabel: '2026-06-20 13:00',
    updatedAt: '2026-04-20 16:20',
    editHref: '/admin/events/90000000-0000-0000-0000-000000000002/edit',
    slotsHref: '/admin/events/90000000-0000-0000-0000-000000000002/edit#slots',
    applicationsHref: '/admin/events/90000000-0000-0000-0000-000000000002/applications',
  },
  {
    id: '90000000-0000-0000-0000-000000000003',
    title: '京都講座 下書き',
    guidance: '京都講座の案内下書きです。',
    summary: '未公開イベントです。',
    eventType: 'spot',
    eventTypeLabel: '単発セミナー',
    organizerId: '93000000-0000-0000-0000-000000000001',
    organizerName: '東京教室運営',
    scheduleRuleJson: '{\n  "kind": "single"\n}',
    image: '',
    slots: [],
    isPublished: false,
    isActive: true,
    slotsCount: 0,
    applicationsCount: 0,
    nextSlotLabel: '',
    updatedAt: '2026-04-18 11:00',
    editHref: '/admin/events/90000000-0000-0000-0000-000000000003/edit',
    slotsHref: '/admin/events/90000000-0000-0000-0000-000000000003/edit#slots',
    applicationsHref: '/admin/events/90000000-0000-0000-0000-000000000003/applications',
  },
];

const adminEventApplicationRowsByEventId = {
  '90000000-0000-0000-0000-000000000002': [
    {
      id: '91000000-0000-0000-0000-000000000001',
      applicantName: '申込 花子',
      applicantEmail: 'applicant1@example.com',
      classificationLabel: '一般',
      slotLabel: '2026-06-20 13:00',
      slotParticipationLabel: '第1コマ',
      slotFeeLabel: '8,000円',
      applicationStatus: 'applied',
      statusLabel: '受付済',
      contactStatusLabel: '未連絡',
      createdAt: '2026-04-18 10:24',
      note: '初回参加。案内メール未送信。',
    },
    {
      id: '91000000-0000-0000-0000-000000000002',
      applicantName: '山田 太郎',
      applicantEmail: 'member1@example.com',
      classificationLabel: '会員',
      slotLabel: '2026-06-20 13:00',
      slotParticipationLabel: '第1コマ',
      slotFeeLabel: '8,000円',
      applicationStatus: 'applied',
      statusLabel: '受付済',
      contactStatusLabel: '連絡済',
      createdAt: '2026-04-18 11:40',
      note: '会員申込。参加費確認済み。',
    },
    {
      id: '91000000-0000-0000-0000-000000000003',
      applicantName: '問い合わせ 太郎',
      applicantEmail: 'applicant2@example.com',
      classificationLabel: '一般',
      slotLabel: '2026-06-21 10:00',
      slotParticipationLabel: '第2コマ',
      slotFeeLabel: '6,000円',
      applicationStatus: 'applied',
      statusLabel: '確認中',
      contactStatusLabel: '要連絡',
      createdAt: '2026-04-19 09:12',
      note: '日程相談あり。',
    },
    {
      id: '91000000-0000-0000-0000-000000000004',
      applicantName: '取消 例子',
      applicantEmail: 'cancelled@example.com',
      classificationLabel: '一般',
      slotLabel: '2026-06-21 10:00',
      slotParticipationLabel: '第2コマ',
      slotFeeLabel: '6,000円',
      applicationStatus: 'canceled',
      statusLabel: 'キャンセル済',
      contactStatusLabel: '連絡済',
      createdAt: '2026-04-19 10:40',
      note: 'Canceled のため一覧には表示しない前提の seed です。',
    },
  ],
  '90000000-0000-0000-0000-000000000003': [],
};

const adminEventDetailRecords = Object.fromEntries(
  adminEventRows.map((row) => [
    row.id,
    {
      id: row.id,
      title: row.title,
      guidance: row.guidance,
      summary: row.summary,
      eventType: row.eventType,
      organizerId: row.organizerId || '',
      organizerName: row.organizerName || '',
      scheduleRuleJson: row.scheduleRuleJson,
      image: row.image,
      slots: row.slots || [],
      standardStartAt: row.standardStartAt || '',
      standardEndAt: row.standardEndAt || '',
      weekday: row.weekday || '',
      standardFacilityId: row.standardFacilityId || '',
      standardRoomId: row.standardRoomId || '',
      standardAddress: row.standardAddress || '',
      standardRoomName: row.standardRoomName || '',
      standardCapacity: row.standardCapacity || '',
      standardSlotFee: row.standardSlotFee || '',
      standardInstructorId: row.standardInstructorId || '',
      standardInstructor: row.standardInstructor || '',
      isPublished: row.isPublished,
      isActive: row.isActive,
      slotsCount: row.slotsCount,
      applicationsCount: row.applicationsCount,
      nextSlotLabel: row.nextSlotLabel || '未設定',
      updatedAt: row.updatedAt,
    },
  ]),
);

const supportPageContent = Object.assign({
  '/blog': {
    header: {
      title: 'ブログ',
      paragraphs: [],
    },
    entries: blogEntries,
  },
  '/reviews': {
    header: {
      title: 'ご感想',
      imageLabel: 'reviews image area',
      paragraphs: [
        'こちらでは書籍『揺腕法』に頂いたご感想をご紹介しています。',
      ],
      notes: [
        '※掲載順不同です。',
        '※フェースブックやXに頂いた文章を、ご許可を頂いたうえで掲載させていただいています。',
      ],
      contributorsTitle: 'ご寄稿者一覧（お名前をクリックするとリンクに飛びます）',
      contributors: [],
    },
    entries: [],
  },
  '/contact': {
    header: {
      title: 'お問い合わせ',
      paragraphs: [
        '揺腕の内容や講座情報、地方出張や個人レッスンのお申し込み、取材などのお問い合わせはこちらからお願いします。',
        'お気軽にお問い合わせください。',
      ],
    },
    guidance: {
      title: 'ご案内',
      paragraphs: [],
      channels: [],
    },
    form: {
      title: 'お問い合わせフォーム',
      lead: '',
      labels: {
        name: 'お名前',
        nameKana: 'ふりがな',
        email: 'メールアドレス',
        phone: '電話番号',
        message: 'お問い合わせ内容',
        newsOptIn: 'メールでのお知らせ',
      },
      newsOptInLabel: '揺腕法に関するお知らせをメールで受け取る',
      newsOptInHelp: '講座・セミナー・書籍・更新情報などをお送りする場合があります。配信はメール内のリンクからいつでも停止できます。',
      errors: {
        required: 'この項目は必須です。',
      },
      submitLabel: '送信',
      pendingMessage: '送信しています。',
      successMessage: 'お問い合わせを受け付けました。',
      errorMessage: 'お問い合わせを送信できませんでした。入力内容を確認してください。',
    },
  },
  '/mail-magazine': {
    header: {
      title: 'メルマガ登録',
      paragraphs: [
        '東京教室（高田馬場・早稲田）教室を中心とした揺腕法情報を月に２〜３回送信しています。ご希望の方はこちらからご登録ください。',
      ],
    },
    guidance: {
      paragraphs: [],
      channels: [],
    },
    form: {
      lead: '',
      labels: {
        name: 'お名前',
        nameKana: 'ふりがな',
        email: 'メールアドレス',
        attended: '揺腕法の教室に参加したことは',
        source: 'このサイトは何で知りましたか？',
        message: 'メッセージ',
      },
      options: {
        attended: ['あります', 'ありません'],
        source: [
          '書籍『揺腕法』から',
          '検索から',
          'Xから',
          'Facebookから',
          '関係者から直接',
          'その他のSNSから',
          'その他',
        ],
      },
      errors: {
        required: 'この項目は必須です。',
      },
      submitLabel: '登録する',
      pendingMessage: '登録しています。',
      successMessage: 'お知らせ配信の登録を受け付けました。',
      errorMessage: 'お知らせ配信の登録ができませんでした。入力内容を確認してください。',
    },
  },
  '/login': {
    header: {
      title: 'ログイン',
      paragraphs: [],
    },
    form: {
      labels: {
        email: 'メールアドレス',
        password: 'パスワード',
      },
      forgotPasswordLabel: 'パスワードを忘れた方',
      forgotPasswordHref: '/password-reset',
      errors: {
        required: 'この項目は必須です。',
      },
      submitLabel: 'ログイン',
      pendingMessage: 'ログインしています。',
    },
  },
  '/password-reset': {
    header: {
      title: 'パスワードを忘れた方',
      paragraphs: [
        'ご登録のメールアドレスを入力してください。',
      ],
    },
    form: {
      labels: {
        email: 'メールアドレス',
      },
      errors: {
        required: 'この項目は必須です。',
      },
      submitLabel: '再設定メールを送る',
      pendingMessage: '',
    },
  },
  '/password-reset/confirm': {
    header: {
      title: '新しいパスワードを設定',
      paragraphs: [
        '受け取った確認コードと新しいパスワードを入力してください。',
      ],
    },
    form: {
      labels: {
        token: '確認コード',
        newPassword: '新しいパスワード',
        newPasswordConfirm: '新しいパスワード（確認）',
      },
      errors: {
        required: 'この項目は必須です。',
        passwordMismatch: '確認用パスワードが一致しません。',
      },
      submitLabel: '新しいパスワードを設定',
      pendingMessage: '新しいパスワードを設定しています。',
    },
  },
  '/password-setup/confirm': {
    header: {
      title: '初回パスワードを設定',
      paragraphs: [
        '新しいパスワードを入力してください。設定が完了すると、ログインできるようになります。',
      ],
    },
    form: {
      labels: {
        newPassword: '新しいパスワード',
        newPasswordConfirm: '新しいパスワード（確認）',
      },
      errors: {
        required: 'この項目は必須です。',
        tokenMissing: '確認用の情報が見つかりません。受け取ったメールのリンクから開いてください。',
        passwordMismatch: '確認用パスワードが一致しません。',
        passwordTooShort: 'パスワードは8文字以上で入力してください。',
        passwordTooLong: 'パスワードは128文字以内で入力してください。',
        passwordNumericOnly: '数字のみのパスワードは使用できません。',
      },
      helpText: {
        newPassword:
          '8文字以上で設定してください。数字のみ、一般的すぎる文字列、メールアドレスや名前に近い文字列は使用できません。',
      },
      submitLabel: 'パスワードを設定',
      pendingMessage: 'パスワードを設定しています。',
      successMessage: 'パスワードを設定しました',
      errorMessage: 'パスワード設定に失敗しました。リンクの有効期限や入力内容をご確認ください。',
      apiErrorMessages: {
        password_validation_failed:
          'パスワードの条件を満たしていません。表示された内容を確認して、別のパスワードを入力してください。',
        passwordValidationFailed:
          'パスワードの条件を満たしていません。表示された内容を確認して、別のパスワードを入力してください。',
        invalid_or_expired_token:
          'リンクが無効、または有効期限が切れています。最新のメールのリンクから開き直すか、管理者へ再送をご依頼ください。',
        invalid_request:
          'このリンクではパスワード設定を完了できません。最新のメールのリンクから開き直すか、管理者へご確認ください。',
        inactive_request:
          'このリンクはすでに無効です。再送後の古いメールを開いている可能性があります。最新のメールをご確認ください。',
        password_already_set:
          'このアカウントはすでにパスワード設定済みです。ログイン画面からログインしてください。',
        password_setup_failed:
          'パスワード設定に失敗しました。リンクと入力内容をご確認ください。',
        password_setup_conflict:
          'このリンクではパスワード設定を完了できません。最新のメールをご確認ください。',
      },
    },
  },
  '/mypage': {
    header: {
      title: 'マイページ',
      paragraphs: [],
    },
    memberProfileLoadErrorMessage: 'プロフィール情報を読み込めませんでした。',
    accountNotificationLoadErrorMessage: 'メール配信設定を読み込めませんでした。',
    accountNotificationUpdatedMessage: 'メール配信設定を更新しました。',
    accountNotificationUpdateErrorMessage: 'メール配信設定を更新できませんでした。',
    adminMailSummaryLoadErrorMessage: '管理者メール状況を読み込めませんでした。',
    sections: [
      {
        kind: 'accountSummary',
        title: '登録情報',
        lead: 'ログイン中のアカウント情報です。',
        emptyEmailLabel: '-',
        fields: [
          { key: 'email', label: 'ログインメールアドレス' },
          { key: 'roles', label: 'アカウント種別' },
        ],
      },
      {
        kind: 'profileSummary',
        title: '会員プロフィール',
        lead: '会員として保持される基本情報の表示領域です。',
        href: '/mypage/profile',
        ctaLabel: '会員プロフィールを編集する',
        createCtaLabel: '会員プロフィールを登録する',
        unavailableTitle: 'プロフィール編集は利用できません',
        unavailableMessage:
          'このアカウントでは会員プロフィールがまだ用意されていないため、プロフィール情報の表示と変更は利用できません。',
        operatorProfileMissingMessage:
          'この管理者アカウントにはプロフィールがまだ登録されていません。プロフィールを登録すると、マイページで基本情報を表示・編集できます。',
        fields: [
          { key: 'name', label: 'お名前' },
          { key: 'email', label: 'メールアドレス' },
          { key: 'phone', label: '電話番号' },
          { key: 'address', label: '住所' },
        ],
      },
      {
        kind: 'membershipSummary',
        title: '会員区分',
        lead: '会員資格や区分に関する表示領域です。',
      },
      {
        kind: 'notificationPreferences',
        title: 'メール配信設定',
        lead: 'BlogとNewsのメール配信を設定します。',
        paragraphs: [
          '講座・セミナー・書籍・更新情報などのメール配信設定を変更できます。',
        ],
        preferences: [
          { key: 'news', label: 'News配信' },
          { key: 'blog', label: 'Blog配信' },
        ],
        enabledLabel: '受信中',
        disabledLabel: '停止中',
        submittingLabel: '更新中...',
      },
      {
        kind: 'adminMailMenu',
        title: '管理者メール',
        lead: '管理者として対応するメールスレッドの確認導線です。',
        paragraphs: [
          '問い合わせや返信の未読状況、対応が必要なメールを確認できます。',
        ],
        linkHref: '/admin/mail',
        linkLabel: '管理者メールを確認する',
        unreadLabel: '未読',
        needsResponseLabel: '要返信',
        openThreadLabel: '対応中',
        unreadBadgeLabel: '未読 {count} 件があります。',
        emptySummaryText: '未読の管理者メールはありません。',
      },
      {
        kind: 'stakeholderMenu',
        title: '関係者プロフィール・管理',
        lead: '講師・主催者として登録されている方向けの確認・編集導線です。',
        paragraphs: [
          '担当している教室・講座、セミナー、公開プロフィールを確認できます。',
        ],
        links: [
          { kind: 'dashboard', label: '関係者ページへ', href: '/stakeholder' },
          { kind: 'instructorProfile', label: '講師プロフィールを編集する', href: '/stakeholder/instructor-profile' },
          { kind: 'organizerProfile', label: '主催者プロフィールを編集する', href: '/stakeholder/organizer-profile' },
        ],
      },
      {
        kind: 'blogAuthorMenu',
        title: 'ブログ執筆者ページ',
        lead: 'ブログ執筆者として登録されている方向けの投稿管理導線です。',
        paragraphs: [],
        links: [
          { label: 'ブログ執筆者ページへ', href: '/blog-author' },
        ],
      },
      {
        kind: 'seminarApplicationsLink',
        title: '参加セミナー',
        lead: 'お申込み済みのセミナーとキャンセル可否を確認する領域です。',
        href: '/mypage/seminars',
        ctaLabel: '参加セミナーを確認する',
        paragraphs: [
          '参加予定、参加済み、キャンセル済みのセミナーを確認できます。',
        ],
      },
      {
        kind: 'emailChange',
        title: 'ログインID（メールアドレス）変更',
        lead: 'ログインIDとして利用するメールアドレスの変更を扱う領域です。',
        paragraphs: [],
        form: {
          labels: {
            currentPassword: '現在のパスワード',
            newEmail: '新しいメールアドレス',
          },
          buttonLabel: '変更する',
          submittingLabel: '変更中...',
          successMessage: 'ログインIDを変更しました。',
          duplicateMessage: 'このメールアドレスはすでに使用されています。',
          errorMessage: 'ログインIDを変更できませんでした。入力内容を確認してください。',
        },
      },
      {
        kind: 'passwordChange',
        title: 'パスワード変更',
        lead: 'ログイン用パスワードを変更する領域です。',
        paragraphs: [],
        form: {
          labels: {
            currentPassword: '現在のパスワード',
            newPassword: '新しいパスワード',
            newPasswordConfirm: '新しいパスワード（確認）',
          },
          buttonLabel: '変更する',
          submittingLabel: '変更中...',
          successMessage: 'パスワードを変更しました。もう一度ログインしてください。',
          errorMessage: 'パスワードを変更できませんでした。入力内容を確認してください。',
        },
      },
    ],
  },
  '/mypage/seminars': {
    header: {
      title: '参加セミナー',
      paragraphs: [
        'お申込み済みのセミナーを確認できます。キャンセル可能な申込は、この画面から手続きできます。',
      ],
    },
    filterLabel: '参加セミナーの表示切替',
    loadingMessage: '参加セミナーを読み込み中',
    loadErrorMessage: '参加セミナーを読み込めませんでした。',
    authPendingMessage: 'ログイン状態を確認しています。',
    backToMyPageLabel: 'マイページへ戻る',
    participationLabel: '参加するコマ',
    feeLabel: '参加費',
    appliedAtLabel: '申込日',
    publicDetailLabel: '公開ページを見る',
    cancelLabel: 'キャンセルする',
    cancelingLabel: 'キャンセル中...',
    cancelConfirmMessage: 'このセミナー申込をキャンセルします。よろしいですか？',
    cancelSuccessMessage: 'セミナー申込をキャンセルしました。',
    cancelErrorMessage: 'セミナー申込をキャンセルできませんでした。状態を確認してください。',
    cancelUnavailableMessage: 'この申込は現在キャンセルできません。',
    emptyMessages: {
      upcoming: '参加予定のセミナーはありません。',
      past: '参加済みのセミナーはありません。',
      canceled: 'キャンセル済みのセミナーはありません。',
      default: '表示できるセミナーはありません。',
    },
  },
  '/mypage/profile': {
    header: {
      title: 'プロフィール更新',
      createTitle: 'プロフィール登録',
      paragraphs: [],
    },
    form: {
      labels: {
        name: 'お名前',
        nameKana: 'ふりがな',
        phone: '電話番号',
        email: 'メールアドレス',
        postalCode: '郵便番号',
        address: '住所',
        note: 'プロフィール・補足',
      },
      readOnlyEmail: '',
      emailHelpText: 'メールアドレスはログインIDとして扱うため、プロフィール編集では変更できません。',
      errors: {
        required: 'この項目は必須です。',
      },
      submitLabel: '更新する',
      createSubmitLabel: '登録する',
      pendingMessage: 'ログイン状態の確認後にプロフィールを更新できます。',
      authPendingMessage: 'ログイン状態を確認しています。',
      memberMissingMessage:
        'このアカウントでは会員プロフィール編集は利用できません。アカウント設定は引き続き利用できます。',
      operatorProfileCreateMessage:
        'この管理者アカウントにはプロフィールがまだ登録されていません。氏名を入力してプロフィールを登録してください。',
      profileLoadErrorMessage: 'プロフィールを読み込めませんでした。',
      profileCreatedMessage: 'プロフィールを登録しました。',
      profileUpdatedMessage: 'プロフィールを更新しました。',
      profileCreateErrorMessage: 'プロフィールを登録できませんでした。',
      profileUpdateErrorMessage: 'プロフィールを更新できませんでした。',
      errorMessagesByCode: {
        operator_access_required: 'このアカウントではプロフィール登録を利用できません。',
        profile_already_exists: 'すでにプロフィールが登録されています。画面を更新して確認してください。',
        member_profile_email_conflict: 'このメールアドレスではプロフィールを登録できません。事務局へ確認してください。',
        profile_email_mismatch: 'ログイン中のメールアドレスとプロフィール登録情報が一致しません。',
        login_email_missing: 'ログインメールアドレスを確認できません。再ログインしてからお試しください。',
      },
    },
  },
  '/stakeholder': {
    header: {
      title: 'Dashboard',
      paragraphs: [
        '講師または主催者として関係している教室・講座、セミナー、公開プロフィールを確認できます。',
        '申込状況と申込メッセージは閲覧専用です。編集、中止、申込キャンセル、参加者へのメール送信は管理者が行います。',
      ],
    },
    navItems: [
      { label: '担当教室・講座', href: '/stakeholder/classes' },
      { label: '担当セミナー', href: '/stakeholder/seminars' },
      { label: '講師プロフィール', href: '/stakeholder/instructor-profile' },
      { label: '主催者プロフィール', href: '/stakeholder/organizer-profile' },
    ],
    linkGroups: [
      {
        title: '教室・講座 / セミナー',
        body: '関係している教室・講座とセミナーの内容、申込状況、申込メッセージを確認します。',
        links: [
          { label: '担当教室・講座', href: '/stakeholder/classes', metricKey: 'classesCount' },
          { label: '担当セミナー', href: '/stakeholder/seminars', metricKey: 'seminarsCount' },
        ],
      },
      {
        title: 'プロフィール',
        body: '公開プロフィールとして表示される講師情報・主催者情報を確認し、必要な範囲で更新します。',
        links: [
          { label: '講師プロフィール', href: '/stakeholder/instructor-profile', metricKey: 'instructorsCount' },
          { label: '主催者プロフィール', href: '/stakeholder/organizer-profile', metricKey: 'organizersCount' },
        ],
      },
    ],
    loadErrorMessage: '関係者ページを読み込めませんでした。',
  },
  '/blog-author': {
    header: {
      title: 'ブログ執筆者',
      paragraphs: [
        'ブログ執筆者として、自身の投稿を確認・作成・編集できます。',
        '公開権限がない場合は下書き作成・編集まで行い、公開は管理者が行います。',
      ],
    },
    navItems: [
      { label: 'Dashboard', href: '/blog-author' },
      { label: '投稿一覧', href: '/blog-author/posts' },
      { label: '新規投稿', href: '/blog-author/posts/new' },
    ],
    linkGroups: [
      {
        title: '投稿管理',
        body: '自身のブログ投稿を確認し、新しい投稿を作成します。',
        links: [
          { label: '投稿一覧', href: '/blog-author/posts' },
          { label: '新規投稿を作成', href: '/blog-author/posts/new' },
        ],
      },
    ],
  },
  '/blog-author/posts': {
    header: {
      title: 'ブログ投稿一覧',
      paragraphs: [
        '自身が著者として紐づいているブログ投稿を確認します。',
      ],
    },
    loadErrorMessage: '投稿を読み込めませんでした。',
  },
  '/blog-author/posts/new': {
    header: {
      title: 'ブログ投稿作成',
      paragraphs: [
        '新しいブログ投稿を作成します。slugは作成後に編集できません。',
      ],
    },
    form: {
      labels: {
        title: '記事タイトル',
        slug: 'slug',
        isPublished: '公開する',
        publishedAt: '公開開始日時',
        excerpt: '抜粋',
        body: '本文',
        primaryImage: '画像',
      },
      mediaAssetField: createPrimaryImageField('blog'),
      defaults: {
        title: '',
        slug: '',
        isPublished: false,
        publishedAt: '',
        excerpt: '',
        body: '',
        primary_image_id: '',
      },
      errors: {
        required: 'この項目は必須です。',
        invalidSlug: 'slugは半角英数字、ハイフン、アンダースコアで入力してください。日本語は使えません。',
      },
      slugHelpText: '任意項目です。公開URLの末尾に使われます。半角英数字、ハイフン、アンダースコアのみ入力できます。空欄の場合はタイトルから自動生成されます。',
      publishedAtHelpText: '公開面の記事日付としても表示されます。未来日時を指定した場合、その時刻までは公開面に表示されません。',
      excerptMaxLength: 255,
      excerptHelpText: '一覧・関連記事・SEO descriptionなどで短く表示する文章です。255文字以内で入力してください。',
      bodyHelpText: '公開ブログ詳細の本文です。段落を分ける場合は空行で区切ってください。',
      noPublishPermissionHelpText: 'このアカウントでは公開状態を変更できません。投稿は下書きとして保存され、公開は管理者が行います。',
      submitLabel: '投稿を保存',
      pendingMessage: '保存しています。',
    },
  },
  '/blog-author/posts/:postId/edit': {
    header: {
      title: 'ブログ投稿編集',
      paragraphs: [
        '自身のブログ投稿を編集します。slugは公開URLとSEOの安定性を守るため編集できません。',
      ],
    },
    form: {
      labels: {
        title: '記事タイトル',
        slug: 'slug',
        isPublished: '公開する',
        publishedAt: '公開開始日時',
        excerpt: '抜粋',
        body: '本文',
        primaryImage: '画像',
      },
      mediaAssetField: createPrimaryImageField('blog'),
      errors: {
        required: 'この項目は必須です。',
        invalidSlug: 'slugは半角英数字、ハイフン、アンダースコアで入力してください。日本語は使えません。',
      },
      slugReadOnlyHelpText: 'slugは作成時のみ設定できます。公開URLとSEOの安定性を守るため、編集画面では変更できません。',
      publishedAtHelpText: '公開面の記事日付としても表示されます。未来日時を指定した場合、その時刻までは公開面に表示されません。',
      excerptMaxLength: 255,
      excerptHelpText: '一覧・関連記事・SEO descriptionなどで短く表示する文章です。255文字以内で入力してください。',
      bodyHelpText: '公開ブログ詳細の本文です。段落を分ける場合は空行で区切ってください。',
      noPublishPermissionHelpText: 'このアカウントでは公開状態を変更できません。公開判断は管理者が行います。',
      submitLabel: '変更を保存',
      pendingMessage: '保存しています。',
      loadErrorMessage: '投稿を読み込めませんでした。',
    },
  },
  '/stakeholder/classes': {
    navKind: 'classes',
    header: {
      title: '担当教室・講座',
      paragraphs: [
        '主催または担当している教室・講座と申込状況を確認できます。',
        'この画面は閲覧専用です。編集や申込キャンセルは管理者が行います。',
      ],
    },
    searchPlaceholder: '教室・講座 / 主催者 / 講師 / 開催予定',
    loadErrorMessage: '担当教室・講座を読み込めませんでした。',
  },
  '/stakeholder/classes/:classId': {
    header: {
      title: '担当教室・講座詳細',
      paragraphs: [
        '担当教室・講座の基本情報、開催スケジュール、会場、講師を確認します。',
      ],
    },
    loadErrorMessage: '担当教室・講座詳細を読み込めませんでした。',
  },
  '/stakeholder/classes/:classId/applications': {
    header: {
      title: '担当教室・講座申込一覧',
      paragraphs: [
        '担当教室・講座の申込者、希望日・枠、受付状態、申込メッセージを確認します。',
      ],
    },
    searchPlaceholder: '申込者 / メール / 希望日・枠 / 状態 / メッセージ',
    loadErrorMessage: '申込一覧を読み込めませんでした。',
  },
  '/stakeholder/profile': {
    header: {
      title: '講師・主催者プロフィール',
      paragraphs: [
        '講師または主催者として公開されるプロフィール情報を確認・更新できます。',
        '稼働状態と公開可否の変更が必要な場合は管理者へご相談ください。',
      ],
    },
    form: {
      pendingMessage: 'プロフィールを保存しています。',
      updatedMessage: 'プロフィールを保存しました。',
    },
    loadErrorMessage: 'プロフィールを読み込めませんでした。',
  },
  '/stakeholder/instructor-profile': {
    header: {
      title: '講師プロフィール',
      paragraphs: [
        '講師として公開されるプロフィール情報を確認・更新できます。',
        '稼働状態と公開可否の変更が必要な場合は管理者へご相談ください。',
      ],
    },
    form: {
      pendingMessage: '講師プロフィールを保存しています。',
      updatedMessage: '講師プロフィールを保存しました。',
    },
    loadErrorMessage: '講師プロフィールを読み込めませんでした。',
    emptyMessage: '更新できる講師プロフィールはありません。',
  },
  '/stakeholder/organizer-profile': {
    header: {
      title: '主催者プロフィール',
      paragraphs: [
        '主催者として公開されるプロフィール情報を確認・更新できます。',
        '稼働状態と公開可否の変更が必要な場合は管理者へご相談ください。',
      ],
    },
    form: {
      pendingMessage: '主催者プロフィールを保存しています。',
      updatedMessage: '主催者プロフィールを保存しました。',
    },
    loadErrorMessage: '主催者プロフィールを読み込めませんでした。',
    emptyMessage: 'このアカウントに紐づく主催者プロフィールがAPIから返っていません。主催者Accessと主催者プロフィールの紐づきを確認してください。',
  },
  '/stakeholder/seminars': {
    navKind: 'seminars',
    header: {
      title: '担当セミナー',
      paragraphs: [
        '講師・主催者として関係しているセミナーと申込状況を確認できます。',
        'この画面は閲覧専用です。編集、中止、申込キャンセル、参加者へのメール送信は管理者が行います。',
      ],
    },
    searchPlaceholder: 'セミナー / 主催者 / 講師 / 開催日時',
    loadErrorMessage: '担当セミナーを読み込めませんでした。',
  },
  '/stakeholder/seminars/:eventId': {
    header: {
      title: '担当セミナー詳細',
      paragraphs: [
        '担当セミナーの基本情報、開催コマ、会場、講師、持ち物を確認します。',
      ],
    },
    loadErrorMessage: '担当セミナー詳細を読み込めませんでした。',
  },
  '/stakeholder/seminars/:eventId/applications': {
    header: {
      title: '担当セミナー申込一覧',
      paragraphs: [
        '担当セミナーの申込者、参加対象、参加費、受付状態を確認します。',
      ],
    },
    searchPlaceholder: '申込者 / メール / 参加対象 / 状態',
    loadErrorMessage: '申込一覧を読み込めませんでした。',
  },
  '/stakeholder/seminars/:eventId/application-messages': {
    header: {
      title: '担当セミナー申込メッセージ',
      paragraphs: [
        '申込時に入力されたメッセージを確認します。連絡対応が必要な場合は管理者へ共有してください。',
      ],
    },
    searchPlaceholder: '申込者 / メール / 参加対象 / メッセージ',
    loadErrorMessage: '申込メッセージを読み込めませんでした。',
  },
  '/admin': {
    header: {
      title: 'Dashboard',
      paragraphs: [
        '揺腕法Webサイトの各種コンテンツ、会員、教室・セミナー、通知履歴を管理するための入口です。',
        '必要な管理項目を左ナビまたは下のリンクから選択してください。',
      ],
    },
    navGroups: [
      {
        title: 'コンテンツ',
        items: [
          { label: 'ページコンテンツ', href: '/admin/content/page-contents' },
          { label: '創始者', href: '/admin/content/founder' },
          { label: 'ブログ', href: '/admin/content/blog' },
          { label: 'お知らせ', href: '/admin/content/news' },
          { label: '受講者の声', href: '/admin/content/reviews' },
        ],
      },
      {
        title: '人物・権限',
        items: [
          { label: '会員', href: '/admin/members' },
          { label: '会員資格', href: '/admin/access/member' },
          { label: '管理者', href: '/admin/operators' },
          { label: '管理権限', href: '/admin/access/operator' },
          { label: '講師', href: '/admin/events/instructors' },
          { label: '主催者', href: '/admin/events/organizers' },
          { label: 'ブログ執筆者', href: '/admin/content/blog-authors' },
          { label: '問い合わせ・申込者', href: '/admin/applicants' },
          { label: '通知宛先', href: '/admin/notifications/recipients' },
        ],
      },
      {
        title: '教室・セミナー',
        items: [
          { label: '教室', href: '/admin/events/classes' },
          { label: 'セミナー', href: '/admin/events/seminars' },
          { label: '施設', href: '/admin/events/facilities' },
          { label: '部屋', href: '/admin/events/rooms' },
        ],
      },
      {
        title: 'メール・通知',
        items: [
          { label: 'メール', href: '/admin/mail' },
          { label: '通知履歴', href: '/admin/notifications' },
          { label: '通知ルール', href: '/admin/notifications/policies' },
        ],
      },
      {
        title: 'デプロイ・検証',
        items: [
          { label: 'Staging表示状態', href: '/admin/deploy/staging-domain-fallback' },
        ],
      },
    ],
    linkGroups: [
      {
        title: 'コンテンツ',
        body: '公開ページに表示するページコンテンツ、創始者、ブログ、お知らせ、受講者の声を管理します。',
        links: [
          { label: 'ページコンテンツ一覧へ', href: '/admin/content/page-contents' },
          { label: '創始者一覧へ', href: '/admin/content/founder' },
          { label: 'ブログ一覧へ', href: '/admin/content/blog' },
          { label: 'お知らせ一覧へ', href: '/admin/content/news' },
          { label: '受講者の声一覧へ', href: '/admin/content/reviews' },
        ],
      },
      {
        title: '人物・権限',
        body: '会員、管理者、講師、主催者、ブログ執筆者、通知宛先など、人物とログイン権限・資格状態を管理します。',
        links: [
          { label: '会員一覧へ', href: '/admin/members' },
          { label: '会員資格一覧へ', href: '/admin/access/member' },
          { label: '管理者一覧へ', href: '/admin/operators' },
          { label: '管理権限一覧へ', href: '/admin/access/operator' },
          { label: '講師一覧へ', href: '/admin/events/instructors' },
          { label: '主催者一覧へ', href: '/admin/events/organizers' },
          { label: 'ブログ執筆者一覧へ', href: '/admin/content/blog-authors' },
          { label: '問い合わせ・申込者一覧へ', href: '/admin/applicants' },
          { label: '通知宛先へ', href: '/admin/notifications/recipients' },
        ],
      },
      {
        title: '教室・セミナー',
        body: '教室、セミナー、施設、部屋、参加者情報を管理します。講師・主催者は人物・権限から管理します。',
        links: [
          { label: '教室一覧へ', href: '/admin/events/classes' },
          { label: 'セミナー一覧へ', href: '/admin/events/seminars' },
          { label: '施設一覧へ', href: '/admin/events/facilities' },
          { label: '部屋一覧へ', href: '/admin/events/rooms' },
        ],
      },
      {
        title: 'メール・通知',
        body: '管理者からの個別メール、返信のあるメールスレッド、自動通知の履歴と送信判断を確認します。個別の宛先は人物・権限から確認します。',
        links: [
          { label: 'メールへ', href: '/admin/mail' },
          { label: '通知履歴へ', href: '/admin/notifications' },
          { label: '通知ルールへ', href: '/admin/notifications/policies' },
        ],
      },
      {
        title: 'デプロイ・検証',
        body: '実ドメイン設定前のStaging検証に必要な表示切替と、デプロイ前後の確認導線を扱います。',
        links: [
          { label: 'Staging表示状態へ', href: '/admin/deploy/staging-domain-fallback' },
        ],
      },
    ],
  },
  '/admin/deploy/staging-domain-fallback': {
    activeNavHref: '/admin/deploy/staging-domain-fallback',
    routeKey: '/admin/deploy/staging-domain-fallback',
    header: {
      title: 'Staging表示状態',
      paragraphs: [
        'StagingのHerokuapp fallback表示について、現在の設定を読み取り専用で確認します。',
        '通常は実ドメインによるhost-based routingが正です。変更は1Password AppとNodeV11 Envkit V3を使用します。',
      ],
    },
    statePanel: {
      title: '現在の切替状態',
      lead: 'API側のSuperuser専用GETを通じて、Herokuapp fallback表示用Config Varsの安全な状態だけを確認します。この画面からの直接更新は退役済みです。',
    },
    labels: {
      appName: 'Heroku app',
      environment: 'API環境',
      enabled: 'fallback',
      target: '表示対象',
      allowedTargets: '選択可能な対象',
    },
    messages: {
      loadError: 'Staging表示状態を読み込めませんでした。',
    },
    notes: {
      title: '運用メモ',
      items: [
        'host-based routing が正本です。yowan-stg.shimashou.com / yowan.jp が正常な場合は、この手動切替より自動判定を優先します。',
        '正本の変更は1Password Appで行い、NodeV11で `python3 deploy/envkit_v3/sync-heroku.py dry-run --environment staging` を確認します。',
        '承認後はNodeV11で `python3 deploy/envkit_v3/sync-heroku.py apply --environment staging --confirm-environment staging` を実行します。',
        '同期後はHerokuのrelease/restart完了後にHerokuappのroot URLを更新して確認してください。',
        '/index.html を直接開く検証は対象外です。実ドメインまたはHerokuappのroot URLで確認してください。',
        '読み取り用Heroku API KeyはAPI側だけで保持し、ブラウザには渡しません。',
      ],
    },
  },
  '/admin/mail': {
    activeNavHref: '/admin/mail',
    routeKey: '/admin/mail',
    header: {
      title: 'メール',
      paragraphs: [
        '管理者が送受信したメールをスレッド単位で確認します。',
        '任意の宛先への新規メール送信と、受信返信への返信をこの画面から行います。',
      ],
    },
    searchPlaceholder: '相手メール / 相手名 / 件名 / 最新本文',
    emptyMessage: '表示できるメールスレッドはありません。',
    loadErrorMessage: 'メールスレッドを読み込めませんでした。',
  },
  '/admin/mail/new': {
    activeNavHref: '/admin/mail',
    routeKey: '/admin/mail/new',
    header: {
      title: '新規メール',
      paragraphs: [
        '送信元を選び、任意の宛先へメールを送信します。',
        '送信元は登録済みのメール送信元から選択します。送信後はメールスレッドとして保存され、返信があれば同じスレッドで確認できます。',
      ],
    },
    senderIdentityLoadErrorMessage: '送信元候補を読み込めませんでした。',
    form: {
      labels: {
        senderIdentity: '送信元',
        to: '宛先',
        cc: 'Cc',
        bcc: 'Bcc',
        subject: '件名',
        body: '本文',
      },
      senderIdentityHelpText: '共通送信元または管理者個人の送信元から選択します。送信元の登録・編集は別の管理導線で扱います。',
      addressHelpText: 'To / Cc / Bcc はカンマ、セミコロン、改行で複数指定できます。複数Toの場合は、宛先ごとに個別のメールスレッドとして作成されます。',
      submitLabel: '送信する',
      pendingMessage: '送信を受け付けています。',
      successMessage: 'メール送信を受け付けました。メール一覧で確認してください。',
      bulkSuccessMessage: '{count}件のメール送信を受け付けました。宛先ごとに個別のメールスレッドを作成しました。',
      bulkListLinkLabel: 'メール一覧へ',
      errorMessage: 'メール送信を受け付けられませんでした。入力内容と送信元を確認してください。',
    },
  },
  '/admin/mail/threads/:threadId': {
    activeNavHref: '/admin/mail',
    routeKey: '/admin/mail/threads/:threadId',
    header: {
      title: 'メールスレッド',
      paragraphs: [
        '送受信メールを時系列で確認し、同じスレッドへ返信します。',
      ],
    },
    loadErrorMessage: 'メールスレッドを読み込めませんでした。',
    notFoundMessage: '指定されたメールスレッドは見つかりませんでした。',
    emptyMessagesText: 'このスレッドには表示できるメールがありません。',
    messageMeta: {
      openLabel: 'ヘッダー情報を表示',
      closeLabel: 'ヘッダー情報を隠す',
    },
    messageQuote: {
      openLabel: '引用部分を表示',
      closeLabel: '引用部分を隠す',
    },
    replyForm: {
      title: '返信',
      actionAreaLabel: '返信操作',
      openLabel: '返信する',
      closeLabel: '返信フォームを閉じる',
      labels: {
        senderIdentity: '送信元',
        cc: 'Cc',
        bcc: 'Bcc',
        body: '本文',
      },
      senderIdentityHelpText: '返信に使用する送信元を選択します。',
      submitLabel: '返信する',
      pendingMessage: '返信送信を受け付けています。',
      sentMessage: '返信送信を受け付けました。配送状況はスレッド内の送信状態で確認してください。',
      errorMessage: '返信送信を受け付けられませんでした。入力内容と送信元を確認してください。',
    },
  },
  '/admin/mail/threads/:threadId/status': {
    activeNavHref: '/admin/mail',
    routeKey: '/admin/mail/threads/:threadId/status',
    header: {
      title: '対応状態を変更',
      paragraphs: [
        'メールスレッドの対応状態だけを変更します。',
        '送受信履歴や返信本文には影響しません。',
      ],
    },
    loadErrorMessage: 'メールスレッドを読み込めませんでした。',
    notFoundMessage: '指定されたメールスレッドは見つかりませんでした。',
    form: {
      label: '対応状態',
      helpText: '管理者が内部的に扱う対応状態です。相手には通知されません。',
      submitLabel: '状態を更新',
      pendingMessage: '更新中です。',
      updatedMessage: '対応状態を更新しました。',
      errorMessage: '対応状態を更新できませんでした。',
    },
  },
  '/admin/notifications': {
    activeNavHref: '/admin/notifications',
    routeKey: '/admin/notifications',
    header: {
      title: '通知履歴',
      paragraphs: [
        '申込、問合せ、自動返信、セミナー連絡などの送信履歴を確認します。',
        '送信結果、宛先、件名、本文、失敗理由を確認できます。通知宛先詳細から個別メールアドレスでの確認導線も用意します。',
      ],
    },
    rows: [],
  },
  '/admin/notifications/policies': {
    activeNavHref: '/admin/notifications/policies',
    routeKey: '/admin/notifications/policies',
    header: {
      title: '通知ルール',
      paragraphs: [
        '通知イベントごとの送信判断、宛先グループ、テンプレートを確認します。',
        'この画面では送信する / 送信しない / 未決定の判断だけを変更できます。',
      ],
    },
  },
  '/admin/notifications/recipients': {
    activeNavHref: '/admin/notifications/recipients',
    routeKey: '/admin/notifications/recipients',
    header: {
      title: '通知宛先',
      paragraphs: [
        '通知全体の宛先グループと、通知可能な宛先台帳を確認します。',
        'お知らせ / ブログは受信設定も宛先リストで確認できます。実際に送信された宛先は通知履歴詳細で確認します。',
      ],
    },
  },
  '/admin/notifications/recipients/:recipientId': {
    activeNavHref: '/admin/notifications/recipients',
    routeKey: '/admin/notifications/recipients/:recipientId',
    header: {
      title: '通知宛先詳細',
      paragraphs: [
        '通知宛先の基本情報、関連導線、カテゴリ別の受信設定、宛先生成元を確認します。この画面では編集しません。',
        '会員・関係者・ブログ執筆者など複数の役割が同じメールアドレスに紐づく場合は、宛先生成元で由来を確認できます。',
      ],
    },
  },
  '/admin/notifications/policies/:eventKey': {
    activeNavHref: '/admin/notifications/policies',
    routeKey: '/admin/notifications/policies/:eventKey',
    header: {
      title: '通知ルール詳細',
      paragraphs: [
        '通知イベントの送信判断と参照する宛先グループを確認します。宛先グループ全体は通知宛先で確認できます。',
      ],
    },
  },
  '/notifications/unsubscribe': {
    header: {
      title: '配信停止',
      paragraphs: [
        'メール配信の停止内容を確認します。',
      ],
    },
  },
  '/admin/notifications/:dispatchId': {
    activeNavHref: '/admin/notifications',
    routeKey: '/admin/notifications/:dispatchId',
    header: {
      title: '通知詳細',
      paragraphs: [
        '送信履歴の詳細を確認します。宛先、件名、本文、送信元情報、失敗理由を確認できます。',
      ],
    },
    recordsById: adminNotificationDetailRecords,
  },
  '/admin/events/facilities': {
    activeNavHref: '/admin/events/facilities',
    routeKey: '/admin/events/facilities',
    header: {
      title: '施設管理',
      paragraphs: [
        'セミナーや常設クラスで使用する施設情報を管理します。',
      ],
    },
    primaryAction: {
      label: '新規施設を作成',
      href: '/admin/events/facilities/new',
    },
    relatedLinks: [
      { label: '部屋一覧', href: '/admin/events/rooms' },
      { label: '教室一覧', href: '/admin/events/classes' },
      { label: 'セミナー一覧', href: '/admin/events/seminars' },
    ],
    rows: adminFacilityRows,
  },
  '/admin/events/facilities/new': {
    activeNavHref: '/admin/events/facilities',
    routeKey: '/admin/events/facilities/new',
    header: {
      title: '施設新規作成',
      paragraphs: [
        '新しい施設を登録します。必要に応じて、施設内の部屋も追加してください。',
      ],
    },
    relatedLinks: [
      { label: '部屋一覧', href: '/admin/events/rooms' },
      { label: '教室一覧', href: '/admin/events/classes' },
      { label: 'セミナー一覧', href: '/admin/events/seminars' },
    ],
    form: {
      labels: {
        facilityName: '施設名',
        shortName: '略称',
        address: '住所',
        phone: '電話番号',
        gmap: 'Google Map URL',
        url: '施設URL',
        publicLocationLabel: '公開用の場所表示',
        accessNote: 'アクセス説明',
        privateLocationNote: '申込後案内',
        image: '施設画像',
        isActive: '使用中',
        remarks: '備考',
      },
      roomLabels: {
        sectionTitle: '部屋',
        sectionLead: '部屋は施設に紐づく従属情報です。不要な部屋は入力欄から外すと、保存時に新規作成対象から外れます。',
        addButton: '部屋を追加',
        itemTitle: '部屋',
        roomName: '部屋名',
        capacity: '定員目安',
        isActive: '使用中',
        remarks: '備考',
      },
      defaults: {
        facilityName: '',
        shortName: '',
        address: '',
        phone: '',
        gmap: '',
        url: '',
        publicLocationLabel: '',
        accessNote: '',
        privateLocationNote: '',
        primary_image_id: '',
        image: '',
        isActive: true,
        remarks: '',
        rooms: [
          {
            roomName: '',
            capacity: '',
            isActive: true,
            remarks: '',
          },
        ],
      },
      errors: {
        required: 'この項目は必須です。',
      },
      helpText: {
        facilityName: '公開面・管理面の両方で使う正式名称です。',
        shortName: '一覧や選択肢で短く表示したい場合に使います。',
        address: '施設の所在地を入力します。',
        phone: '公開されている連絡先がある場合のみ入力します。',
        gmap: '公開ページや案内メールから会場地図へ誘導するために使用します。',
        publicLocationLabel: '施設名や住所を公開面にそのまま出さない場合の代替表示です。',
        accessNote: '施設までの一般的なアクセス説明です。公開面の案内に使用できます。',
        privateLocationNote: '申込後メールや管理面で使う詳細な会場案内です。公開面にはそのまま出さない前提です。',
        image: '画像を登録する場合に使用します。',
        isActive: '使用停止した施設は、新しい教室やセミナーの選択肢から外します。',
        rooms: '部屋は施設に紐づけて管理します。',
      },
      submitLabel: '施設を登録',
      pendingMessage: '保存しています。',
    },
  },
  '/admin/events/facilities/:facilityId/edit': {
    activeNavHref: '/admin/events/facilities',
    routeKey: '/admin/events/facilities/:facilityId/edit',
    header: {
      title: '施設編集',
      paragraphs: [
        '施設情報と、この施設に紐づく部屋を編集します。',
      ],
    },
    relatedLinks: [
      { label: '部屋一覧', href: '/admin/events/rooms' },
      { label: '教室一覧', href: '/admin/events/classes' },
      { label: 'セミナー一覧', href: '/admin/events/seminars' },
    ],
    form: {
      labels: {
        facilityName: '施設名',
        shortName: '略称',
        address: '住所',
        phone: '電話番号',
        gmap: 'Google Map URL',
        url: '施設URL',
        publicLocationLabel: '公開用の場所表示',
        accessNote: 'アクセス説明',
        privateLocationNote: '申込後案内',
        image: '施設画像',
        isActive: '使用中',
        remarks: '備考',
      },
      roomLabels: {
        sectionTitle: '部屋',
        sectionLead: '既存の部屋を入力欄から外して保存すると、運用上は使用停止・除外として扱われます。単なる誤入力の削除と混同しないよう注意してください。',
        addButton: '部屋を追加',
        itemTitle: '部屋',
        roomName: '部屋名',
        capacity: '定員目安',
        isActive: '使用中',
        remarks: '備考',
      },
      errors: {
        required: 'この項目は必須です。',
      },
      helpText: {
        facilityName: '公開面・管理面の両方で使う正式名称です。',
        shortName: '一覧や選択肢で短く表示したい場合に使います。',
        address: '施設の所在地を入力します。',
        phone: '公開されている連絡先がある場合のみ入力します。',
        gmap: '公開ページや案内メールから会場地図へ誘導するために使用します。',
        publicLocationLabel: '施設名や住所を公開面にそのまま出さない場合の代替表示です。',
        accessNote: '施設までの一般的なアクセス説明です。公開面の案内に使用できます。',
        privateLocationNote: '申込後メールや管理面で使う詳細な会場案内です。公開面にはそのまま出さない前提です。',
        image: '画像を登録する場合に使用します。',
        isActive: '使用停止した施設は、新しい教室やセミナーの選択肢から外します。',
        rooms: '部屋は施設に紐づけて管理します。',
      },
      submitLabel: '変更を保存',
      pendingMessage: '保存しています。',
    },
    recordsById: adminFacilityDetailRecords,
  },
  '/admin/events/rooms': {
    activeNavHref: '/admin/events/rooms',
    routeKey: '/admin/events/rooms',
    header: {
      title: '部屋管理',
      paragraphs: [
        '施設に紐づく部屋情報を確認します。部屋の追加は施設の登録・編集画面から行います。',
        '施設一覧の「部屋」から遷移した場合は、対象施設の部屋だけを表示します。',
      ],
    },
    relatedLinks: [
      { label: '施設一覧', href: '/admin/events/facilities' },
      { label: '教室一覧', href: '/admin/events/classes' },
      { label: 'セミナー一覧', href: '/admin/events/seminars' },
    ],
    rows: adminRoomRows,
  },
  '/admin/events/rooms/:roomId/edit': {
    activeNavHref: '/admin/events/rooms',
    routeKey: '/admin/events/rooms/:roomId/edit',
    header: {
      title: '部屋編集',
      paragraphs: [
        '部屋名、定員目安、使用状態を編集します。',
      ],
    },
    relatedLinks: [
      { label: '施設一覧', href: '/admin/events/facilities' },
      { label: '教室一覧', href: '/admin/events/classes' },
      { label: 'セミナー一覧', href: '/admin/events/seminars' },
    ],
    form: {
      labels: {
        roomName: '部屋名',
        facilityId: '所属施設',
        capacity: '定員目安',
        isActive: '使用中',
        remarks: '備考',
      },
      options: {
        facilities: adminFacilityOptions,
      },
      errors: {
        required: 'この項目は必須です。',
      },
      helpText: {
        roomName: '同じ施設内で識別できる部屋名を入れます。',
        facilityId: '所属施設はこの画面では変更できません。',
        capacity: '定員の目安として使用します。',
        isActive: '使用停止した部屋は、新しい教室やセミナーの選択肢から外します。',
      },
      submitLabel: '変更を保存',
      pendingMessage: '保存しています。',
    },
    recordsById: adminRoomDetailRecords,
  },
  '/admin/events/instructors': {
    activeNavHref: '/admin/events/instructors',
    routeKey: '/admin/events/instructors',
    header: {
      title: '講師管理',
      paragraphs: [
        '講師プロフィール、連絡先、公開状態、稼働状態を管理します。',
      ],
    },
    primaryAction: {
      label: '新規講師を作成',
      href: '/admin/events/instructors/new',
    },
    relatedLinks: [
      { label: '会員一覧', href: '/admin/members' },
      { label: '会員資格一覧', href: '/admin/access/member' },
      { label: '教室一覧', href: '/admin/events/classes' },
      { label: 'セミナー一覧', href: '/admin/events/seminars' },
      { label: '主催者一覧', href: '/admin/events/organizers' },
    ],
    rows: adminInstructorRows,
  },
  '/admin/events/instructors/new': {
    activeNavHref: '/admin/events/instructors',
    routeKey: '/admin/events/instructors/new',
    header: {
      title: '講師新規作成',
      paragraphs: [
        '新しい講師プロフィールを登録します。会員と紐づけることも、外部講師として登録することもできます。',
      ],
    },
    relatedLinks: [
      { label: '講師一覧', href: '/admin/events/instructors' },
      { label: '主催者一覧', href: '/admin/events/organizers' },
      { label: '会員一覧', href: '/admin/members' },
      { label: '会員資格一覧', href: '/admin/access/member' },
    ],
    form: {
      labels: {
        instructorName: '講師名',
        instructorEmail: 'メールアドレス',
        memberId: '紐づく会員',
        personalUrl: '個人URL',
        webLinkWebsite: 'Webサイト',
        webLinkFacebook: 'Facebook',
        webLinkX: 'X',
        webLinkInstagram: 'Instagram',
        webLinkYoutube: 'YouTube',
        webLinkTiktok: 'TikTok',
        webLinkOther: 'その他リンク',
        roleLabel: '肩書き',
        biography: '略歴',
        career: '経歴',
        image: '肖像',
        specialties: '専門領域 / タグ',
        isActive: '稼働中',
        publicProfileEnabled: '公開プロフィール',
        remarks: '備考',
      },
      options: {
        members: adminInstructorMemberOptions,
      },
      defaults: Object.assign({
        instructorName: '',
        instructorEmail: '',
        memberId: '',
        personalUrl: '',
        webLinkWebsite: '',
        webLinkFacebook: '',
        webLinkX: '',
        webLinkInstagram: '',
        webLinkYoutube: '',
        webLinkTiktok: '',
        webLinkOther: '',
        roleLabel: '',
        biography: '',
        career: '',
        primary_image_id: '',
        image: '',
        specialties: '',
        isActive: true,
        publicProfileEnabled: false,
        remarks: '',
      }, yowanPersonLedgerDefaults),
      errors: {
        required: 'この項目は必須です。',
      },
      validation: {
        biographyMaxLength: 220,
        careerMaxLength: 800,
      },
      helpText: {
        instructorName: '公開面・管理面で使う講師表示名です。',
        instructorEmail: '講師プロフィール用の連絡先です。',
        memberId: '会員と紐づける場合に選択します。選択肢には、講師プロフィールをまだ持たない会員だけを表示します。',
        personalUrl: '個人サイトやプロフィールページがある場合に設定します。',
        webLinks: '公開教室詳細の講師紹介に表示する外部リンクです。URLは http または https で入力してください。',
        roleLabel: '一覧や公開プロフィールで短く表示する肩書きです。',
        biography: '公開プロフィールの導入文として使う短い略歴です。220文字以内で入力してください。',
        career: '公開教室詳細の講師紹介本文として使う経歴です。800文字以内で入力してください。',
        image: '肖像画像を登録する場合に使用します。',
        isActive: '稼働停止した講師は、新しい教室やセミナーの選択肢から外します。',
        publicProfileEnabled: '公開ページにプロフィールを表示する場合に有効にします。',
      },
      personLedger: yowanPersonLedgerFormContent,
      submitLabel: '講師を登録',
      pendingMessage: '保存しています。',
    },
  },
  '/admin/events/instructors/:instructorId/edit': {
    activeNavHref: '/admin/events/instructors',
    routeKey: '/admin/events/instructors/:instructorId/edit',
    header: {
      title: '講師編集',
      paragraphs: [
        '講師プロフィール、連絡先、公開状態、稼働状態を編集します。',
      ],
    },
    relatedLinks: [
      { label: '講師一覧', href: '/admin/events/instructors' },
      { label: '主催者一覧', href: '/admin/events/organizers' },
      { label: '会員一覧', href: '/admin/members' },
      { label: '会員資格一覧', href: '/admin/access/member' },
    ],
    form: {
      labels: {
        instructorName: '講師名',
        instructorEmail: 'メールアドレス',
        memberId: '紐づく会員',
        personalUrl: '個人URL',
        webLinkWebsite: 'Webサイト',
        webLinkFacebook: 'Facebook',
        webLinkX: 'X',
        webLinkInstagram: 'Instagram',
        webLinkYoutube: 'YouTube',
        webLinkTiktok: 'TikTok',
        webLinkOther: 'その他リンク',
        roleLabel: '肩書き',
        biography: '略歴',
        career: '経歴',
        image: '肖像',
        specialties: '専門領域 / タグ',
        isActive: '稼働中',
        publicProfileEnabled: '公開プロフィール',
        remarks: '備考',
      },
      options: {
        members: adminInstructorMemberOptions,
      },
      errors: {
        required: 'この項目は必須です。',
      },
      validation: {
        biographyMaxLength: 220,
        careerMaxLength: 800,
      },
      helpText: {
        instructorName: '公開面・管理面で使う講師表示名です。',
        instructorEmail: '講師プロフィール用の連絡先です。',
        memberId: '会員と紐づける場合に選択します。現在の紐づき先と、講師プロフィールをまだ持たない会員だけを表示します。',
        personalUrl: '個人サイトやプロフィールページがある場合に設定します。',
        webLinks: '公開教室詳細の講師紹介に表示する外部リンクです。URLは http または https で入力してください。',
        roleLabel: '一覧や公開プロフィールで短く表示する肩書きです。',
        biography: '公開プロフィールの導入文として使う短い略歴です。220文字以内で入力してください。',
        career: '公開教室詳細の講師紹介本文として使う経歴です。800文字以内で入力してください。',
        image: '肖像画像を登録する場合に使用します。',
        isActive: '稼働停止した講師は、新しい教室やセミナーの選択肢から外します。',
        publicProfileEnabled: '公開ページにプロフィールを表示する場合に有効にします。',
      },
      personLedger: yowanPersonLedgerFormContent,
      stakeholderAccess: {
        title: '講師ログイン権限',
        lead: '講師が自分に関係するセミナー、申込、申込メッセージだけを閲覧できるようにします。編集、中止、キャンセル、参加者メール送信はできません。',
        emailLabel: 'ログインメールアドレス',
        readyText: '認証主体と閲覧権限は設定済みです。追加操作は不要です。',
        actionLabels: {
          send_auth_invite: '認証招待を送信',
          grant_access: '閲覧権限を付与',
          resend_invite: '招待メールを再送',
          none: '',
        },
      },
      membershipAccess: {
        title: '会員資格',
        lead: '講師が会員でもある場合に、同じログインアカウントへ会員プロフィールと会員資格を付与します。講師ログイン権限とは別の資格です。',
        authLabel: '認証主体',
        memberLabel: '会員プロフィール',
        emailLabel: '対象メールアドレス',
        actionLabel: '会員資格を付与',
        readyText: '会員プロフィールは作成済みです。会員資格の有効/停止は会員資格管理で確認してください。',
        authRequiredText: '先に講師ログイン権限の認証主体を作成してください。',
        pendingMessage: '会員資格を付与しています。',
        successMessage: '会員資格を付与しました。',
        errorMessage: '会員資格を付与できませんでした。対象アカウントの状態を確認してください。',
      },
      submitLabel: '変更を保存',
      pendingMessage: '保存しています。',
    },
    recordsById: adminInstructorDetailRecords,
  },
  '/admin/events/organizers': {
    activeNavHref: '/admin/events/organizers',
    routeKey: '/admin/events/organizers',
    header: {
      title: '主催者管理',
      paragraphs: [
        '教室やセミナーの開催責任主体を管理します。主催者は個人・団体のどちらも扱えます。',
      ],
    },
    primaryAction: {
      label: '新規主催者を作成',
      href: '/admin/events/organizers/new',
    },
    relatedLinks: [
      { label: '教室一覧', href: '/admin/events/classes' },
      { label: 'セミナー一覧', href: '/admin/events/seminars' },
      { label: '講師一覧', href: '/admin/events/instructors' },
      { label: '会員資格一覧', href: '/admin/access/member' },
    ],
    rows: adminOrganizerRows,
  },
  '/admin/events/organizers/new': {
    activeNavHref: '/admin/events/organizers',
    routeKey: '/admin/events/organizers/new',
    header: {
      title: '主催者新規作成',
      paragraphs: [
        '新しい主催者を登録します。会員と紐づく主催者も、外部個人・外部団体の主催者も扱えます。',
      ],
    },
    relatedLinks: [
      { label: '主催者一覧', href: '/admin/events/organizers' },
      { label: '会員一覧', href: '/admin/members' },
      { label: '会員資格一覧', href: '/admin/access/member' },
    ],
    form: {
      labels: {
        organizerName: '主催者名',
        organizerType: '種別',
        memberId: '紐づく会員',
        representativeName: '代表者名',
        contactEmail: '連絡先メールアドレス',
        contactPhone: '連絡先電話番号',
        websiteUrl: 'WebサイトURL',
        image: '画像',
        description: '説明文',
        publicProfileEnabled: '公開プロフィール',
        isActive: '稼働中',
        remarks: '備考',
      },
      options: {
        organizerType: [
          { value: 'individual', label: '個人' },
          { value: 'group', label: '団体' },
        ],
        members: adminOrganizerMemberOptions,
      },
      defaults: Object.assign({
        organizerName: '',
        organizerType: 'individual',
        memberId: '',
        representativeName: '',
        contactEmail: '',
        contactPhone: '',
        websiteUrl: '',
        primary_image_id: '',
        image: '',
        description: '',
        publicProfileEnabled: false,
        isActive: true,
        remarks: '',
      }, yowanPersonLedgerDefaults),
      errors: {
        required: 'この項目は必須です。',
      },
      validation: {
        descriptionMaxLength: 800,
      },
      helpText: {
        organizerName: '公開面・管理面で使う主催者表示名です。',
        organizerType: '個人主催か団体主催かを選択します。',
        memberId: '会員と紐づける場合に選択します。選択肢には、主催者プロフィールをまだ持たない会員だけを表示します。',
        contactEmail: '主催者への運用連絡に使うメールアドレスです。',
        websiteUrl: '主催者サイトや紹介ページがある場合に設定します。',
        image: '主催者画像を登録する場合に使用します。',
        description: '公開プロフィールを有効にした場合、主催者紹介文として表示する想定です。800文字以内で入力してください。',
        isActive: '稼働停止した主催者は、新しい教室やセミナーの選択肢から外します。',
        publicProfileEnabled: '公開ページに主催者情報を表示する場合に有効にします。',
      },
      personLedger: yowanPersonLedgerFormContent,
      submitLabel: '主催者を登録',
      pendingMessage: '保存しています。',
    },
  },
  '/admin/events/organizers/:organizerId/edit': {
    activeNavHref: '/admin/events/organizers',
    routeKey: '/admin/events/organizers/:organizerId/edit',
    header: {
      title: '主催者編集',
      paragraphs: [
        '主催者情報、会員との紐づき、公開状態、稼働状態を編集します。',
      ],
    },
    relatedLinks: [
      { label: '主催者一覧', href: '/admin/events/organizers' },
      { label: '会員一覧', href: '/admin/members' },
      { label: '会員資格一覧', href: '/admin/access/member' },
    ],
    form: {
      labels: {
        organizerName: '主催者名',
        organizerType: '種別',
        memberId: '紐づく会員',
        representativeName: '代表者名',
        contactEmail: '連絡先メールアドレス',
        contactPhone: '連絡先電話番号',
        websiteUrl: 'WebサイトURL',
        image: '画像',
        description: '説明文',
        publicProfileEnabled: '公開プロフィール',
        isActive: '稼働中',
        remarks: '備考',
      },
      options: {
        organizerType: [
          { value: 'individual', label: '個人' },
          { value: 'group', label: '団体' },
        ],
        members: adminOrganizerMemberOptions,
      },
      errors: {
        required: 'この項目は必須です。',
      },
      validation: {
        descriptionMaxLength: 800,
      },
      helpText: {
        organizerName: '公開面・管理面で使う主催者表示名です。',
        organizerType: '個人主催か団体主催かを選択します。',
        memberId: '会員と紐づける場合に選択します。現在の紐づき先と、主催者プロフィールをまだ持たない会員だけを表示します。',
        contactEmail: '主催者への運用連絡に使うメールアドレスです。',
        websiteUrl: '主催者サイトや紹介ページがある場合に設定します。',
        image: '主催者画像を登録する場合に使用します。',
        description: '公開プロフィールを有効にした場合、主催者紹介文として表示する想定です。800文字以内で入力してください。',
        isActive: '稼働停止した主催者は、新しい教室やセミナーの選択肢から外します。',
        publicProfileEnabled: '公開ページに主催者情報を表示する場合に有効にします。',
      },
      personLedger: yowanPersonLedgerFormContent,
      stakeholderAccess: {
        title: '主催者ログイン権限',
        lead: '主催者が自分に関係するセミナー、申込、申込メッセージだけを閲覧できるようにします。編集、中止、キャンセル、参加者メール送信はできません。',
        emailLabel: 'ログインメールアドレス',
        readyText: '認証主体と閲覧権限は設定済みです。追加操作は不要です。',
        actionLabels: {
          send_auth_invite: '認証招待を送信',
          grant_access: '閲覧権限を付与',
          resend_invite: '招待メールを再送',
          none: '',
        },
      },
      membershipAccess: {
        title: '会員資格',
        lead: '主催者が会員でもある場合に、同じログインアカウントへ会員プロフィールと会員資格を付与します。主催者ログイン権限とは別の資格です。',
        authLabel: '認証主体',
        memberLabel: '会員プロフィール',
        emailLabel: '対象メールアドレス',
        actionLabel: '会員資格を付与',
        readyText: '会員プロフィールは作成済みです。会員資格の有効/停止は会員資格管理で確認してください。',
        authRequiredText: '先に主催者ログイン権限の認証主体を作成してください。',
        pendingMessage: '会員資格を付与しています。',
        successMessage: '会員資格を付与しました。',
        errorMessage: '会員資格を付与できませんでした。対象アカウントの状態を確認してください。',
      },
      submitLabel: '変更を保存',
      pendingMessage: '保存しています。',
    },
    recordsById: adminOrganizerDetailRecords,
  },
  '/admin/events/classes': {
    activeNavHref: '/admin/events/classes',
    routeKey: '/admin/events/classes',
    showChildManagement: false,
    showTypeColumn: false,
    showInstructorColumn: true,
    showClassApplicationsColumn: true,
    titleColumnLabel: '教室名',
    searchPlaceholder: '教室 / 講師 / 公開 / 有効',
    searchKeys: [
      (row) => row.title,
      (row) => row.standardInstructor,
      (row) => (row.isPublished ? '公開中' : '非公開'),
      (row) => (row.isActive ? 'active' : 'inactive'),
    ],
    header: {
      title: '教室管理',
      paragraphs: [
        '常設クラスの教室情報、講師、標準開催日時、公開状態を管理します。',
      ],
    },
    primaryAction: {
      label: '新規教室を作成',
      href: '/admin/events/new?type=regular',
    },
    rows: [],
  },
  '/admin/events/classes/:classId/applications': {
    activeNavHref: '/admin/events/classes',
    routeKey: '/admin/events/classes/:classId/applications',
    header: {
      title: '教室申込者一覧',
      paragraphs: [
        '常設クラスの申込者を確認します。公開教室詳細フォームから送信された申込を開催予定単位で扱います。',
      ],
    },
    rowsByClassId: {},
    classRecordsById: adminEventDetailRecords,
  },
  '/admin/events/classes/applications/:applicationId': {
    activeNavHref: '/admin/events/classes',
    routeKey: '/admin/events/classes/applications/:applicationId',
    header: {
      title: '教室申込詳細',
      paragraphs: [
        '教室申込の内容、希望開催情報、受付状態を確認します。申込時点の情報と同一メールアドレスの観測履歴は管理メモとは分けて扱います。',
      ],
    },
    recordsById: {},
  },
  '/admin/events/seminars': {
    activeNavHref: '/admin/events/seminars',
    routeKey: '/admin/events/seminars',
    showChildManagement: true,
    showTypeColumn: false,
    showParticipantsColumn: true,
    showInstructorColumn: true,
    slotCountColumnLabel: 'コマ',
    dateTimeColumnLabel: '開催日時',
    sortOptions: [
      { value: 'created-desc', label: '作成日が新しい順' },
      { value: 'updated-desc', label: '更新日が新しい順' },
      { value: 'published-status', label: '公開ステータス順' },
      { value: 'active-status', label: '有効状態順' },
      { value: 'title-asc', label: 'セミナー昇順' },
      { value: 'title-desc', label: 'セミナー降順' },
    ],
    titleColumnLabel: 'セミナー名',
    searchPlaceholder: 'セミナー / 公開 / 有効 / 開催日時',
    searchKeys: [
      (row) => row.title,
      (row) => (row.isPublished ? '公開中' : '非公開'),
      (row) => (row.isActive ? 'active' : 'inactive'),
      (row) => row.nextSlotLabel,
    ],
    header: {
      title: 'セミナー管理',
      paragraphs: [
        '単発セミナーの内容、講師、開催日時、参加者情報を管理します。',
      ],
    },
    primaryAction: {
      label: '新規セミナーを作成',
      href: '/admin/events/new',
    },
    rows: [],
  },
  '/admin/events/series/:seriesId': {
    activeNavHref: '/admin/events/seminars',
    routeKey: '/admin/events/series/:seriesId',
    header: {
      title: 'シリーズ詳細',
      paragraphs: [
        'シリーズとして公開面でまとめる情報と、配下セミナーを確認します。',
      ],
    },
  },
  '/admin/events/series/:seriesId/edit': {
    activeNavHref: '/admin/events/seminars',
    routeKey: '/admin/events/series/:seriesId/edit',
    header: {
      title: 'シリーズ編集',
      paragraphs: [
        'シリーズのタイトル、主催者、通し参加料金、有効状態を編集します。配下セミナーや開催コマは各セミナー編集画面で管理します。',
      ],
    },
  },
  '/admin/events/new': {
    header: {
      title: 'セミナー新規作成',
      paragraphs: [
        '新しい単発セミナーを作成します。開催日時や会場、料金はコマごとに設定してください。',
      ],
    },
    form: {
      labels: {
        title: 'セミナー名',
        subtitle: 'サブタイトル',
        publicSlug: '公開URL slug',
        seriesKind: 'セミナーの構成',
        seriesTitle: 'シリーズ名',
        seriesSubtitle: 'シリーズ補足',
        seriesSummary: 'シリーズ概要',
        seriesOrganizerId: 'シリーズ主催者',
        seriesFullParticipationFee: 'シリーズ通し参加料金',
        seriesImage: 'シリーズヘッダー画像',
        eventType: '種別',
        organizerId: '主催者',
        isPublished: '公開する',
        acceptsApplications: '申込受付中',
        isActive: undefined,
        summary: '概要',
        fullParticipationFee: '通し参加料金',
        guidance: '案内文',
        image: '画像',
      },
      slotLabels: {
        sectionTitle: '開催コマ',
        sectionLead: '開催日時、会場、定員、料金などをコマ単位で追加します。',
        addButton: '開催コマを追加',
        itemTitle: '開催コマ',
        title: 'コマタイトル',
        startAt: '開始日時',
        endAt: '終了日時',
        facility: '施設',
        room: '部屋',
        locationDisplayMode: '公開場所',
        publicLocationLabel: '公開場所ラベル',
        publicLocationNote: '公開場所補足',
        privateLocationNote: '内部向け場所メモ',
        thingsToBring: '持ち物',
        capacity: '定員',
        slotFee: '料金',
        instructor: '講師',
        showInstructorProfile: '講師紹介を公開する',
        isOpen: '受付中',
        isActive: '開催コマを表示する',
      },
      seminarBlockLabels: {
        sectionTitle: 'セミナー',
        sectionLead: 'シリーズに含めるセミナーを追加します。各セミナーの中に開催コマを設定します。',
        addButton: 'セミナーを追加',
        itemTitle: 'セミナー',
        removeButton: '×',
      },
      options: {
        eventType: [
          { value: 'spot', label: '単発セミナー' },
        ],
        seriesKind: [
          { value: 'standalone', label: '単独セミナー' },
          { value: 'grouped', label: 'シリーズ' },
        ],
        organizers: adminOrganizerOptions,
        instructors: adminInstructorOptions,
        facilities: adminFacilityOptions,
        rooms: adminRoomOptions,
        locationDisplayModes: adminLocationDisplayModeOptions,
      },
      eventTypeLocked: true,
      imageInputType: 'file',
      defaults: {
        title: '',
        subtitle: '',
        publicSlug: '',
        seriesKind: 'standalone',
        seriesTitle: '',
        seriesSubtitle: '',
        seriesSummary: '',
        seriesOrganizerId: '',
        seriesFullParticipationFee: '',
        seriesImage: '',
        series_primary_image_id: '',
        eventType: 'spot',
        organizerId: '',
        isPublished: false,
        acceptsApplications: true,
        isActive: true,
        summary: '',
        fullParticipationFee: '',
        guidance: '',
        image: '',
        seminars: [
          {
            title: '',
            subtitle: '',
            organizerId: '',
            isPublished: false,
            acceptsApplications: true,
            isActive: true,
            summary: '',
            fullParticipationFee: '',
            guidance: '',
            image: '',
            slots: [
              {
                title: '',
                startAt: '',
                endAt: '',
                facilityId: '',
                roomId: '',
                locationDisplayMode: 'facility',
                publicLocationLabel: '',
                publicLocationNote: '',
                privateLocationNote: '',
                thingsToBring: '',
                capacity: '',
                slotFee: '',
                instructorId: '',
                showInstructorProfile: false,
                isOpen: true,
                isActive: true,
              },
            ],
          },
          {
            title: '',
            subtitle: '',
            organizerId: '',
            isPublished: false,
            acceptsApplications: true,
            isActive: true,
            summary: '',
            fullParticipationFee: '',
            guidance: '',
            image: '',
            slots: [
              {
                title: '',
                startAt: '',
                endAt: '',
                facilityId: '',
                roomId: '',
                locationDisplayMode: 'facility',
                publicLocationLabel: '',
                publicLocationNote: '',
                privateLocationNote: '',
                thingsToBring: '',
                capacity: '',
                slotFee: '',
                instructorId: '',
                showInstructorProfile: false,
                isOpen: true,
                isActive: true,
              },
            ],
          },
        ],
        slots: [
          {
            title: '',
            startAt: '',
            endAt: '',
            facilityId: '',
            roomId: '',
            locationDisplayMode: 'facility',
            publicLocationLabel: '',
            publicLocationNote: '',
            privateLocationNote: '',
            thingsToBring: '',
            capacity: '',
            slotFee: '',
            instructorId: '',
            showInstructorProfile: false,
            isOpen: true,
            isActive: true,
          },
        ],
      },
      errors: {
        required: 'この項目は必須です。',
        invalidDateTimeRange: '終了日時は開始日時以降に設定してください。',
      },
      isPublishedHelpText: '公開面にこのセミナー情報を掲載する場合に有効にします。申込受付の可否は「申込受付中」で別に管理します。',
      acceptsApplicationsHelpText: 'このセミナー全体の申込受付を許可します。停止しても、公開状態が有効なら公開面にはセミナー情報を表示し、申込フォームだけを閉じます。',
      imageHelpText: '公開セミナー詳細の案内エリアと、セミナー一覧カードの代表画像候補として使用します。シリーズではシリーズ画像が設定されている場合、シリーズ画像が優先されます。',
      organizerHelpText: '開催責任を持つ主催者を選択します。',
      subtitleHelpText: '公開面のセミナー名の下に表示する補足タイトルです。',
      publicSlugHelpText: '作成時のみ任意設定できます。公開URLの末尾に使われます。空欄の場合はタイトルから自動生成されます。半角英数字とハイフンのみ入力できます。日本語は使えません。',
      seriesKindHelpText: '単独セミナーは1つのセミナーだけで完結します。シリーズは複数セミナーを公開面でまとめて扱います。',
      seriesTitleHelpText: 'シリーズとして公開面にまとめる場合の大きなタイトルです。単独セミナーではセミナー名が同期されます。',
      seriesSubtitleHelpText: 'シリーズ全体の補足タイトルです。',
      seriesSummaryHelpText: '公開面 /classes のセミナー一覧カードに、シリーズ全体の短い説明として表示されます。配下セミナーの概要文とは別責務です。80文字以内で入力してください。',
      seriesSummaryMaxLength: 80,
      seriesOrganizerHelpText: 'シリーズ全体の主催者です。未選択の場合はセミナー主催者を使います。',
      seriesFullParticipationFeeHelpText: 'シリーズ全体を通して参加する場合の案内料金です。セミナー内の通し参加料金とは別概念です。',
      seriesImageHelpText: '公開シリーズ詳細のヘッダー画像と、/classes のセミナー一覧カード画像として使用します。配下セミナーセクションの画像には流用しません。',
      seminarBlockHelpText: 'シリーズでは2件以上のセミナーを登録します。1件だけで完結する場合は単独セミナーとして登録してください。',
      fullParticipationFeeHelpText: 'このセミナー内の全コマに通しで参加する場合の料金です。シリーズ全体の通し参加料金とは別概念です。',
      summaryHelpText: '公開面のセミナー一覧カードで、単独セミナーの短い説明として表示します。シリーズではシリーズ概要文を使うため、このセミナー概要文は一覧カードへ流用しません。80文字以内で短く入力してください。',
      summaryMaxLength: 80,
      guidanceHelpText: '公開セミナー詳細の案内文として表示します。シリーズでは、このセミナーに対応する案内文として表示します。600文字以内で、内容・対象者・参加後の流れが伝わる文章にしてください。',
      guidanceMaxLength: 600,
      isActiveHelpText: '通常は変更しません。強い停止・中止扱いとして公開面と新規受付の対象から外す場合に使います。',
      facilityHelpText: '公開場所を「施設・部屋を公開」にした場合、公開面の開催日程カセットに施設名と部屋名が表示されます。',
      roomHelpText: '施設と部屋を公開する場合に表示される部屋です。施設のみを案内したい場合や秘匿したい場合は、公開場所の扱いで調整してください。',
      locationDisplayModeHelpText: '公開面の開催日程カセットに出す場所表示を制御します。施設・部屋を公開する場合は施設/部屋を表示し、秘匿する場合は公開場所ラベルを表示します。',
      publicLocationLabelHelpText: '施設や部屋をそのまま公開しない場合に、公開面の場所欄へ表示する代替テキストです。例: 神戸市中央区内の公共施設 / 会場は調整中です。',
      publicLocationNoteHelpText: '公開面の場所表示の下に出す補足です。アクセス、集合場所、公開してよい注意事項だけを入力してください。',
      privateLocationNoteHelpText: '公開面には表示しない管理用メモです。申込後案内に使う場所情報や運用上の注意をまとめて記録します。',
      thingsToBringHelpText: 'このコマに参加する方へ案内する持ち物です。申込完了メールに表示されます。未入力の場合はメール本文に持ち物欄を表示しません。',
      slotTitleHelpText: '公開面の開催日程カセットと申込フォームの選択肢に表示します。未入力の場合は日付と第n部の表記で補完されます。例: 1日目 / 基礎編 / 午前の部',
      slotShowInstructorProfileHelpText: '公開セミナー詳細で、このコマの講師プロフィールを講師紹介として表示します。講師プロフィール側が公開許可されている場合だけ表示されます。',
      slotOpenHelpText: 'この開催コマ単位で申込を受け付ける場合に有効にします。セミナー全体の申込受付が停止中の場合は、ここが有効でも申込できません。',
      slotActiveHelpText: 'この開催コマを公開面・管理面の通常表示対象にする場合に有効にします。表示したくないコマだけを外すための項目です。',
      slotHelpText: '開催日時、会場、定員、料金、講師はコマごとに設定します。施設や部屋を秘匿する場合は公開場所の扱いを切り替えてください。',
      submitLabel: 'セミナーを登録',
      pendingMessage: '保存しています。',
    },
  },
  '/admin/events/classes/new': {
    header: {
      title: '教室 新規作成',
      paragraphs: [
        '新しい常設クラスを作成します。複数の開催日時、会場、講師を開催情報として登録できます。',
      ],
    },
    form: {
      labels: {
        title: '教室名',
        publicSlug: '公開URL slug',
        eventType: '種別',
        organizerId: '主催者',
        isPublished: '公開する',
        acceptsApplications: '申込受付中',
        isActive: '有効にする',
        calendarUrl: 'カレンダーURL',
        showInstructorProfiles: '講師紹介を公開する',
        summary: '概要',
        guidance: '案内文',
        detailTopImage: '詳細Top画像',
        image: '一覧画像',
      },
      scheduleLabels: {
        sectionTitle: '開催情報',
        sectionLead: '曜日・時間・場所・講師を、開催系統ごとに追加します。複数会場や複数時間帯の教室はここで複数登録します。',
        addButton: '開催情報を追加',
        itemTitle: '開催情報',
        scheduleKind: '開催頻度',
        scheduleLabel: '開催表記',
        weekday: '曜日',
        startAt: '標準開始時刻',
        endAt: '標準終了時刻',
        facility: '施設',
        room: '部屋',
        locationDisplayMode: '場所を公開',
        publicLocationLabel: '公開面の場所表示',
        publicLocationNote: '公開場所補足',
        privateLocationNote: '管理用メモ',
        capacity: '定員',
        fee: '標準料金',
        instructor: '講師',
        isActive: 'この開催情報を有効にする',
        remarks: '備考',
      },
      options: {
        eventType: [
          { value: 'regular', label: '常設クラス' },
        ],
        weekday: [
          { value: 'monday', label: '月曜日' },
          { value: 'tuesday', label: '火曜日' },
          { value: 'wednesday', label: '水曜日' },
          { value: 'thursday', label: '木曜日' },
          { value: 'friday', label: '金曜日' },
          { value: 'saturday', label: '土曜日' },
          { value: 'sunday', label: '日曜日' },
        ],
        organizers: adminOrganizerOptions,
        instructors: adminInstructorOptions,
        facilities: adminFacilityOptions,
        rooms: adminRoomOptions,
        locationDisplayModes: adminClassLocationDisplayModeOptions,
        scheduleKinds: adminScheduleKindOptions,
      },
      eventTypeLocked: true,
      imageInputType: 'file',
      defaults: {
        title: '',
        publicSlug: '',
        eventType: 'regular',
        organizerId: '',
        isPublished: false,
        isActive: true,
        calendarUrl: '',
        showInstructorProfiles: false,
        summary: '',
        guidance: '',
        detail_top_image_id: '',
        detailTopImage: '',
        image: '',
        schedules: [
          {
            id: '',
            scheduleKind: 'weekly',
            scheduleLabel: '',
            weekday: 'tuesday',
            startTime: '',
            endTime: '',
            facilityId: '',
            roomId: '',
            locationIsPublic: 'true',
            publicLocationLabel: '',
            publicLocationNote: '',
            privateLocationNote: '',
            capacity: '',
            fee: '',
            instructorId: '',
            isActive: true,
            remarks: '',
          },
        ],
      },
      errors: {
        required: 'この項目は必須です。',
        invalidDateTimeRange: '終了日時は開始日時以降に設定してください。',
      },
      isPublishedHelpText: '公開面に掲載する場合に有効にします。セミナーの申込受付可否は「申込受付中」で別に管理します。',
      detailTopImageHelpText: '公開面の教室詳細ページ上部に表示されます。一覧カード用画像とは別に、横長のTop画像として見せたい画像を登録してください。',
      imageHelpText: '公開面の「教室・講座」一覧カードに表示されます。横長の領域に合わせて一部トリミングされる場合があります。',
      organizerHelpText: '教室の開催責任を持つ主催者を選択します。',
      publicSlugHelpText: '作成時のみ任意設定できます。公開URLの末尾に使われます。空欄の場合はタイトルから自動生成されます。半角英数字とハイフンのみ入力できます。日本語は使えません。',
      summaryHelpText: '公開面の教室一覧カセットに全文表示されます。80文字以内で短く入力してください。',
      summaryMaxLength: 80,
      guidanceHelpText: '公開面の教室詳細ページ「教室について」に表示されます。600文字以内で、対象者・内容・雰囲気が伝わる文章にしてください。',
      guidanceMaxLength: 600,
      isActiveHelpText: '停止した教室は公開面の対象から外します。',
      calendarUrlHelpText: 'Google Calendar 等の外部カレンダーを案内する場合に設定します。',
      showInstructorProfilesHelpText: '公開教室詳細の案内文下に講師紹介を表示します。講師プロフィール側が公開許可されている講師だけが表示対象です。',
      scheduleKindHelpText: '機械的な繰り返し生成ではなく、公開面・管理面での表示分類として扱います。',
      scheduleLabelHelpText: '開催頻度と曜日から自動入力されます。公開面に出す開催頻度・開催区分の表示テキストとして任意に変更できます。',
      locationDisplayModeHelpText: '公開する場合は施設・部屋を公開面に表示します。公開しない場合は、下の公開面の場所表示を使います。',
      publicLocationLabelHelpText: '場所を公開しない場合に公開面へ出す表示です。例: 神戸市中央区内の公共施設 / 会場は調整中です。',
      publicLocationNoteHelpText: '公開面で場所表示の下に出す補足です。具体住所や内部向け情報は書かないでください。',
      privateLocationNoteHelpText: '公開面には表示しない管理用メモです。申込後案内に使う場所情報や運用上の注意をまとめて記録します。',
      submitLabel: '教室を登録',
      pendingMessage: '保存しています。',
    },
  },
  '/admin/events/:eventId/edit': {
    header: {
      title: '教室・セミナー編集',
      paragraphs: [
        '内容、画像、公開状態、開催情報を編集します。',
      ],
    },
    form: {
      labels: {
        title: 'タイトル',
        subtitle: 'サブタイトル',
        publicSlug: '公開URL slug',
        seriesKind: 'セミナーの構成',
        seriesTitle: 'シリーズ名',
        seriesSubtitle: 'シリーズ補足',
        seriesSummary: 'シリーズ概要',
        seriesOrganizerId: 'シリーズ主催者',
        seriesFullParticipationFee: 'シリーズ通し参加料金',
        seriesImage: 'シリーズヘッダー画像',
        eventType: '種別',
        organizerId: '主催者',
        isPublished: '公開する',
        acceptsApplications: '申込受付中',
        isActive: '有効にする',
        calendarUrl: 'カレンダーURL',
        showInstructorProfiles: '講師紹介を公開する',
        summary: '概要',
        fullParticipationFee: '通し参加料金',
        guidance: '案内文',
        scheduleRuleJson: '定期開催設定',
        detailTopImage: '詳細Top画像',
        image: '一覧画像',
      },
      slotLabels: {
        sectionTitle: '開催コマ',
        sectionLead: '既存コマを確認し、必要に応じて追加します。',
        addButton: '開催コマを追加',
        itemTitle: '開催コマ',
        title: 'コマタイトル',
        startAt: '開始日時',
        endAt: '終了日時',
        facility: '施設',
        room: '部屋',
        locationDisplayMode: '公開場所',
        publicLocationLabel: '公開場所ラベル',
        publicLocationNote: '公開場所補足',
        privateLocationNote: '内部向け場所メモ',
        thingsToBring: '持ち物',
        capacity: '定員',
        slotFee: '料金',
        instructor: '講師',
        showInstructorProfile: '講師紹介を公開する',
        isOpen: '受付中',
        isActive: '開催コマを表示する',
      },
      scheduleLabels: {
        sectionTitle: '開催情報',
        sectionLead: '曜日・時間・場所・講師を、開催系統ごとに追加します。複数会場や複数時間帯の教室はここで複数登録します。',
        addButton: '開催情報を追加',
        itemTitle: '開催情報',
        scheduleKind: '開催頻度',
        scheduleLabel: '開催表記',
        weekday: '曜日',
        startAt: '標準開始時刻',
        endAt: '標準終了時刻',
        facility: '施設',
        room: '部屋',
        locationDisplayMode: '場所を公開',
        publicLocationLabel: '公開面の場所表示',
        publicLocationNote: '公開場所補足',
        privateLocationNote: '管理用メモ',
        capacity: '定員',
        fee: '標準料金',
        instructor: '講師',
        isActive: 'この開催情報を有効にする',
        remarks: '備考',
      },
      options: {
        eventType: [
          { value: 'spot', label: '単発セミナー' },
          { value: 'regular', label: '常設クラス' },
        ],
        seriesKind: [
          { value: 'standalone', label: '単独セミナー' },
          { value: 'grouped', label: 'シリーズ' },
        ],
        weekday: [
          { value: 'monday', label: '月曜日' },
          { value: 'tuesday', label: '火曜日' },
          { value: 'wednesday', label: '水曜日' },
          { value: 'thursday', label: '木曜日' },
          { value: 'friday', label: '金曜日' },
          { value: 'saturday', label: '土曜日' },
          { value: 'sunday', label: '日曜日' },
        ],
        organizers: adminOrganizerOptions,
        instructors: adminInstructorOptions,
        facilities: adminFacilityOptions,
        rooms: adminRoomOptions,
        locationDisplayModes: adminLocationDisplayModeOptions,
        classLocationDisplayModes: adminClassLocationDisplayModeOptions,
        scheduleKinds: adminScheduleKindOptions,
      },
      errors: {
        required: 'この項目は必須です。',
        invalidDateTimeRange: '終了日時は開始日時以降に設定してください。',
      },
      isPublishedHelpText: '公開する場合は、公開状態と有効状態の両方を確認してください。',
      acceptsApplicationsHelpText: 'このセミナー全体の申込受付を許可します。停止しても、公開状態が有効なら公開面にはセミナー情報を表示し、申込フォームだけを閉じます。',
      scheduleRuleJsonHelpText: '定期開催の補足設定が必要な場合に使用します。',
      detailTopImageHelpText: '公開面の教室詳細ページ上部に表示されます。一覧カード用画像とは別に、横長のTop画像として見せたい画像を登録してください。',
      imageHelpText: '公開面の「教室・講座」一覧カードに表示されます。横長の領域に合わせて一部トリミングされる場合があります。セミナーでは詳細ページの案内エリアにも表示されます。',
      organizerHelpText: '開催責任を持つ主催者を選択します。',
      subtitleHelpText: 'セミナーでは公開面のセミナー名の下に表示します。',
      publicSlugHelpText: '作成時のみ任意設定できます。公開URLの末尾に使われます。空欄の場合はタイトルから自動生成されます。半角英数字とハイフンのみ入力できます。日本語は使えません。',
      publicSlugReadOnlyHelpText: 'slugは作成時のみ設定できます。公開URLとSEOの安定性を守るため、編集画面では変更できません。',
      seriesKindHelpText: '単独セミナーは1つのセミナーだけで完結します。シリーズは複数セミナーを公開面でまとめて扱います。',
      seriesTitleHelpText: 'シリーズとして公開面にまとめる場合の大きなタイトルです。単独セミナーではセミナー名が同期されます。',
      seriesSubtitleHelpText: 'シリーズ全体の補足タイトルです。',
      seriesSummaryHelpText: '公開面 /classes のセミナー一覧カードに、シリーズ全体の短い説明として表示されます。配下セミナーの概要文とは別責務です。80文字以内で入力してください。',
      seriesSummaryMaxLength: 80,
      seriesOrganizerHelpText: 'シリーズ全体の主催者です。未選択の場合はセミナー主催者を使います。',
      seriesFullParticipationFeeHelpText: 'シリーズ全体を通して参加する場合の案内料金です。セミナー内の通し参加料金とは別概念です。',
      seriesImageHelpText: '公開シリーズ詳細のヘッダー画像と、/classes のセミナー一覧カード画像として使用します。配下セミナーセクションの画像には流用しません。',
      fullParticipationFeeHelpText: 'セミナーの全コマに通しで参加する場合の料金です。シリーズ全体の通し参加料金とは別概念です。',
      summaryHelpText: '常設クラスでは公開面の教室一覧カセットに全文表示します。セミナーでは単独セミナーの一覧カード説明として表示し、シリーズではシリーズ概要文を優先します。80文字以内で短く入力してください。',
      summaryMaxLength: 80,
      guidanceHelpText: '常設クラスでは公開面の教室詳細ページ「教室について」に表示します。セミナーでは公開詳細の案内文として表示します。600文字以内で、対象者・内容・雰囲気が伝わる文章にしてください。',
      guidanceMaxLength: 600,
      isActiveHelpText: '通常は変更しません。強い停止・中止扱いとして公開面と新規受付の対象から外す場合に使います。',
      calendarUrlHelpText: 'Google Calendar 等の外部カレンダーを案内する場合に設定します。',
      showInstructorProfilesHelpText: '公開教室詳細の案内文下に講師紹介を表示します。講師プロフィール側が公開許可されている講師だけが表示対象です。',
      scheduleKindHelpText: '機械的な繰り返し生成ではなく、公開面・管理面での表示分類として扱います。',
      scheduleLabelHelpText: '開催頻度と曜日から自動入力されます。公開面に出す開催頻度・開催区分の表示テキストとして任意に変更できます。',
      facilityHelpText: '公開場所を「施設・部屋を公開」にした場合、公開面の開催日程カセットに施設名と部屋名が表示されます。',
      roomHelpText: '施設と部屋を公開する場合に表示される部屋です。施設のみを案内したい場合や秘匿したい場合は、公開場所の扱いで調整してください。',
      locationDisplayModeHelpText: '公開する場合は施設・部屋を公開面に表示します。公開しない場合は、下の公開面の場所表示を使います。',
      publicLocationLabelHelpText: '場所を公開しない場合に公開面へ出す表示です。例: 神戸市中央区内の公共施設 / 会場は調整中です。',
      publicLocationNoteHelpText: '公開面で場所表示の下に出す補足です。具体住所や内部向け情報は書かないでください。',
      privateLocationNoteHelpText: '公開面には表示しない管理用メモです。申込後案内に使う場所情報や運用上の注意をまとめて記録します。',
      thingsToBringHelpText: 'このコマに参加する方へ案内する持ち物です。申込完了メールに表示されます。未入力の場合はメール本文に持ち物欄を表示しません。',
      slotTitleHelpText: 'セミナーでは公開面の開催日程カセットと申込フォームの選択肢に表示します。未入力の場合は日付と第n部の表記で補完されます。',
      slotShowInstructorProfileHelpText: 'セミナーでは、このコマの講師プロフィールを公開セミナー詳細の講師紹介に出すかを制御します。',
      slotOpenHelpText: 'この開催コマ単位で申込を受け付ける場合に有効にします。セミナー全体の申込受付が停止中の場合は、ここが有効でも申込できません。',
      slotActiveHelpText: 'この開催コマを公開面・管理面の通常表示対象にする場合に有効にします。表示したくないコマだけを外すための項目です。',
      slotHelpText: '開催日時、会場、定員、料金、講師はコマごとに管理します。施設や部屋を秘匿する場合は公開場所の扱いを切り替えてください。',
      submitLabel: '変更を保存',
      pendingMessage: '保存しています。',
      slotsTitle: '開催コマ',
      slotsLead: '開催日時や会場、料金はコマごとに管理します。',
      applicationsTitle: '参加者一覧',
      applicationsLead: '参加者情報は閲覧と運用操作を中心に扱います。',
    },
    cancelAction: {
      editRedirectHelpText: 'この操作はセミナー中止処理を含みます。通常の編集保存では実行できません。タイトル・本文・画像などの通常項目を変更したい場合は、先に有効状態のまま更新してください。',
    },
    reactivateAction: {
      editRedirectHelpText: 'このセミナーは運用再開または公開面復旧の確認が必要です。この編集画面ではタイトル・本文・画像・公開設定・申込受付・開催コマだけを保存し、運用再開処理は実行しません。専用ページで中止処理により落ちた公開設定・開催コマ状態・内部親シリーズ状態を確認してから復旧してください。',
    },
    recordsById: adminEventDetailRecords,
  },
  '/admin/events/:eventId': {
    activeNavHref: '/admin/events/seminars',
    routeKey: '/admin/events/:eventId',
    header: {
      title: 'セミナー詳細',
      paragraphs: [
        'セミナーの構成、開催コマ、参加者導線、シリーズとの関係を確認します。',
      ],
    },
    cancelAction: {
      detailLeadText: '中止は通常の編集保存とは別の専用操作です。公開停止・無効化・開催コマのクローズ・通知ルールに基づく中止通知を、専用ページで確認してから実行します。',
    },
    reactivateAction: {
      detailLeadText: '運用再開は通常の編集保存とは別の専用操作です。中止処理で落ちた運用停止状態・公開設定・開催コマ状態を戻し、単独セミナーの内部親シリーズ停止状態があればあわせて復旧します。申込受付中の設定は現在値を維持します。',
    },
  },
  '/admin/events/:eventId/cancel': {
    activeNavHref: '/admin/events/seminars',
    routeKey: '/admin/events/:eventId/cancel',
    header: {
      title: 'セミナー中止',
      paragraphs: [
        '通常の編集保存とは別に、セミナーの公開停止・無効化・開催コマのクローズ・通知ルールに基づく中止通知を確認して実行します。',
      ],
    },
    confirmMessage: 'セミナーを中止します。このページでは通常項目は保存されず、中止処理だけが実行されます。よろしいですか？',
  },
  '/admin/events/:eventId/reactivate': {
    activeNavHref: '/admin/events/seminars',
    routeKey: '/admin/events/:eventId/reactivate',
    header: {
      title: 'セミナー運用再開',
      paragraphs: [
        '通常の編集保存とは別に、中止処理で落ちた運用停止状態、公開設定、開催コマごとの表示・受付状態を復旧します。単独セミナーの内部親シリーズ停止状態が残っている場合もあわせて復旧します。',
        'セミナー全体の申込受付設定は現在の値を維持します。受付を止めていた場合は、公開面に戻っても申込不可状態を維持します。',
      ],
    },
    confirmMessage: 'セミナーを運用再開します。このページでは通常項目は保存されず、中止処理で落ちた公開面表示に必要な状態を復旧します。よろしいですか？',
  },
  '/admin/events/:eventId/applications': {
    activeNavHref: '/admin/events/seminars',
    routeKey: '/admin/events/:eventId/applications',
    header: {
      title: 'セミナー参加者一覧',
      paragraphs: [
        'セミナーの参加者を確認します。必要に応じて個別連絡やキャンセル処理を行います。',
      ],
    },
    relatedLinks: [
      { label: 'セミナー一覧', href: '/admin/events/seminars' },
    ],
    rowsByEventId: adminEventApplicationRowsByEventId,
    eventRecordsById: adminEventDetailRecords,
  },
  '/admin/events/:eventId/applications/mail': {
    activeNavHref: '/admin/events/seminars',
    routeKey: '/admin/events/:eventId/applications/mail',
    header: {
      title: '参加者メール送信',
      paragraphs: [
        'セミナー参加者への個別連絡、または参加者と内部共有先への一斉送信を作成します。',
      ],
    },
    relatedLinks: [
      { label: 'セミナー一覧', href: '/admin/events/seminars' },
    ],
    form: {
      labels: {
        audienceMode: '宛先',
        subject: '件名',
        body: '本文',
      },
      options: {
        audienceMode: [
          { value: 'all', label: '参加者・関係者全員' },
          { value: 'single', label: '個別連絡' },
        ],
      },
      defaults: {
        audienceMode: 'all',
        subject: '',
        body: '',
      },
      audienceModeHelpText: '一斉送信では、このセミナーに申込済みの参加者と、管理者・主催者・講師などの内部共有先を宛先にします。メールはBCCで送信されます。',
      singleAudienceHelpText: '個別連絡では、対象の1申込者と管理者共有を宛先にします。メールはBCCで送信されます。',
      submitLabel: '送信する',
      errors: {
        required: 'この項目は必須です。',
      },
      pendingMessage: '送信内容の確認を受け付けました。',
    },
    rowsByEventId: adminEventApplicationRowsByEventId,
    eventRecordsById: adminEventDetailRecords,
  },
  '/admin/events/:eventId/application-messages': {
    activeNavHref: '/admin/events/seminars',
    routeKey: '/admin/events/:eventId/application-messages',
    header: {
      title: 'セミナー申込メッセージ一覧',
      paragraphs: [
        'このセミナーの申込時に入力されたメッセージを、本文を確認しやすい形でまとめて確認します。',
        '個別対応が必要なメッセージは、詳細確認または個別連絡へ進んで処理します。',
      ],
    },
  },
  '/admin/events/series/:seriesId/application-messages': {
    activeNavHref: '/admin/events/seminars',
    routeKey: '/admin/events/series/:seriesId/application-messages',
    header: {
      title: 'シリーズ申込メッセージ一覧',
      paragraphs: [
        'このシリーズ配下のセミナー申込メッセージを、本文を確認しやすい形でまとめて確認します。',
        'どのセミナーへの申込かを確認しながら、詳細確認または個別連絡へ進んで処理します。',
      ],
    },
  },
  '/admin/content/blog': {
    header: {
      title: 'ブログ管理',
      paragraphs: [
        'ブログ記事の作成、編集、公開状態の管理を行います。',
      ],
    },
    primaryAction: {
      label: '新規記事を作成',
      href: '/admin/content/blog/new',
    },
    rows: adminBlogRows,
  },
  '/admin/content/blog/new': {
    header: {
      title: 'ブログ新規作成',
      paragraphs: [
        '新しいブログ記事を作成します。公開開始日時を指定して保存します。',
      ],
    },
    form: {
      labels: {
        title: '記事タイトル',
        slug: 'slug',
        isPublished: '公開する',
        publishedAt: '公開開始日時',
        excerpt: '抜粋',
        body: '本文',
        primaryImage: '画像',
      },
      mediaAssetField: createPrimaryImageField('blog'),
      defaults: {
        title: '',
        slug: '',
        isPublished: false,
        publishedAt: '',
        excerpt: '',
        body: '',
        primary_image_id: '',
      },
      errors: {
        required: 'この項目は必須です。',
        invalidSlug: 'slugは半角英数字、ハイフン、アンダースコアで入力してください。日本語は使えません。',
      },
      slugHelpText: '任意項目です。公開URLの末尾に使われます。半角英数字、ハイフン、アンダースコアのみ入力できます。日本語は使えません。大文字は保存時に小文字化されます。空欄のまま保存するとタイトルから自動生成されます。slugは作成後に編集できません。',
      authorField: {
        options: [
          { value: '', label: '著者を指定しない' },
        ],
      },
      authorHelpText: '任意項目です。指定すると公開面のブログ一覧・詳細に著者名が表示されます。プロフィールURLがある著者はリンク化されます。',
      publishedAtHelpText: '必須項目です。未来日時を指定した場合、その時刻までは公開面・SEO・サイトマップに表示されません。公開後は、公開面の記事日付としても表示されます。既存サイトから移行する過去記事は、元記事の日付を指定してください。',
      excerptMaxLength: 255,
      excerptHelpText: '一覧・関連記事・SEO descriptionなどで短く表示する文章です。255文字以内で入力してください。',
      bodyHelpText: '公開ブログ詳細の本文です。SEO descriptionには直接使われません。段落を分ける場合は空行で区切ってください。',
      submitLabel: '下書きを保存',
      pendingMessage: '保存しています。画像の登録に時間がかかる場合があります。',
    },
  },
  '/admin/content/blog/:blogId/edit': {
    header: {
      title: 'ブログ編集',
      paragraphs: [
        'ブログ記事の内容、画像、公開状態を編集します。',
      ],
    },
    form: {
      labels: {
        title: '記事タイトル',
        slug: 'slug',
        author: '著者',
        isPublished: '公開する',
        publishedAt: '公開開始日時',
        excerpt: '抜粋',
        body: '本文',
        primaryImage: '画像',
      },
      mediaAssetField: createPrimaryImageField('blog'),
      errors: {
        required: 'この項目は必須です。',
        invalidSlug: 'slugは半角英数字、ハイフン、アンダースコアで入力してください。日本語は使えません。',
      },
      slugReadOnlyHelpText: 'slugは作成時のみ設定できます。公開URLとSEOの安定性を守るため、編集画面では変更できません。',
      authorField: {
        options: [
          { value: '', label: '著者を指定しない' },
        ],
      },
      authorHelpText: '任意項目です。指定すると公開面のブログ一覧・詳細に著者名が表示されます。プロフィールURLがある著者はリンク化されます。',
      publishedAtHelpText: '必須項目です。未来日時を指定した場合、その時刻までは公開面・SEO・サイトマップに表示されません。公開後は、公開面の記事日付としても表示されます。既存サイトから移行する過去記事は、元記事の日付を指定してください。',
      excerptMaxLength: 255,
      excerptHelpText: '一覧・関連記事・SEO descriptionなどで短く表示する文章です。255文字以内で入力してください。',
      bodyHelpText: '公開ブログ詳細の本文です。SEO descriptionには直接使われません。段落を分ける場合は空行で区切ってください。',
      submitLabel: '変更を保存',
      pendingMessage: '保存しています。画像の登録に時間がかかる場合があります。',
    },
    recordsById: adminBlogDetailRecords,
  },
  '/admin/content/blog-authors': {
    header: {
      title: 'ブログ執筆者管理',
      paragraphs: [
        'ブログ執筆者の認証招待、著者プロフィール、投稿公開権限を管理します。',
        '同じメールアドレスが会員・講師・主催者として登録されている場合でも、ブログ執筆者権限は別の役割として管理されます。',
      ],
    },
    primaryAction: {
      label: '執筆者を登録',
      href: '/admin/content/blog-authors/new',
    },
    searchPlaceholder: '著者名 / メールアドレス / URL',
    filters: {
      isActive: [
        { value: '', label: 'すべて' },
        { value: 'true', label: '有効' },
        { value: 'false', label: '停止中' },
      ],
    },
    loadErrorMessage: 'ブログ執筆者を読み込めませんでした。',
  },
  '/admin/content/blog-authors/new': {
    header: {
      title: 'ブログ執筆者登録',
      paragraphs: [
        'ブログ執筆者としてログインできる権限と、公開面に表示する著者情報を登録します。必要に応じてパスワード設定メールを送信します。',
      ],
    },
    form: {
      labels: {
        email: 'ログインメールアドレス',
        authorName: '著者名',
        profileUrl: 'プロフィールURL',
        canPublishBlog: '本人による公開を許可する',
        isActive: '有効にする',
        sendInvite: 'パスワード設定メールを送信する',
      },
      defaults: Object.assign({
        email: '',
        authorName: '',
        profileUrl: '',
        canPublishBlog: false,
        isActive: true,
        sendInvite: true,
      }, yowanPersonLedgerDefaults),
      errors: {
        required: 'この項目は必須です。',
        invalidUrl: 'URLは https:// から入力してください。',
      },
      emailHelpText: 'このメールアドレス宛にログイン用の案内を送信します。既存の認証主体がある場合は権限を紐づけます。',
      profileUrlHelpText: '任意項目です。公開面の著者名をリンク化する場合のみ https:// から入力してください。',
      canPublishBlogHelpText: 'Offの場合、執筆者本人は下書き作成・編集のみ行えます。公開判断は管理者が行います。',
      sendInviteHelpText: 'Onにすると初回パスワード設定メールを送信します。',
      personLedger: yowanPersonLedgerFormContent,
      submitLabel: '執筆者を登録',
      pendingMessage: '執筆者を登録しています。',
    },
  },
  '/admin/content/blog-authors/:accessId/edit': {
    header: {
      title: 'ブログ執筆者編集',
      paragraphs: [
        'ブログ執筆者の著者情報、投稿公開権限、有効状態を編集します。',
        'ログインメールアドレスは認証主体を示し、公開面に表示する著者名とは別に管理されます。',
      ],
    },
    form: {
      labels: {
        email: 'ログインメールアドレス',
        authorName: '著者名',
        profileUrl: 'プロフィールURL',
        canPublishBlog: '本人による公開を許可する',
        isActive: '有効にする',
      },
      defaults: Object.assign({
        email: '',
        authorName: '',
        profileUrl: '',
        canPublishBlog: false,
        isActive: true,
      }, yowanPersonLedgerDefaults),
      errors: {
        required: 'この項目は必須です。',
        invalidUrl: 'URLは https:// から入力してください。',
      },
      emailHelpText: 'ログインメールアドレスはこの画面では変更できません。',
      profileUrlHelpText: '任意項目です。公開面の著者名をリンク化する場合のみ https:// から入力してください。',
      canPublishBlogHelpText: 'Offの場合、執筆者本人は下書き作成・編集のみ行えます。公開判断は管理者が行います。',
      personLedger: yowanPersonLedgerFormContent,
      loginSetup: {
        title: 'ログイン設定',
        lead: 'ブログ執筆者の初回パスワード設定状況を確認します。メールが届かない場合は、通知履歴と最新依頼の状態を確認してください。',
        authLabel: '認証主体',
        passwordLabel: 'パスワード設定',
        latestRequestLabel: '最新依頼',
        latestStatusLabel: '最新依頼ステータス',
        expiresAtLabel: '有効期限',
        passwordRequiredText: '未設定',
        passwordReadyText: '設定済み',
        latestRequestEmptyText: '依頼なし',
        unknownStatusText: '未取得',
      },
      membershipAccess: {
        title: '会員資格',
        lead: 'ブログ執筆者が会員でもある場合に、同じログインアカウントへ会員プロフィールと会員資格を付与します。ブログ執筆者権限とは別の資格です。',
        authLabel: '認証主体',
        memberLabel: '会員プロフィール',
        memberAccessLabel: '会員資格',
        emailLabel: '対象メールアドレス',
        actionLabel: '会員資格を付与',
        readyText: '会員プロフィールと会員資格は作成済みです。会員資格の有効/停止は会員資格管理で確認してください。',
        authRequiredText: '先にブログ執筆者の認証主体を作成してください。',
        unavailableText: '会員資格を付与できる状態ではありません。対象アカウントの状態を確認してください。',
        pendingMessage: '会員資格を付与しています。',
        successMessage: '会員資格を付与しました。',
        errorMessage: '会員資格を付与できませんでした。対象アカウントの状態を確認してください。',
      },
      submitLabel: '変更を保存',
      pendingMessage: '保存しています。',
      loadErrorMessage: 'ブログ執筆者を読み込めませんでした。',
    },
  },
  '/admin/content/news': {
    header: {
      title: 'お知らせ管理',
      paragraphs: [
        'お知らせの作成、編集、公開状態の管理を行います。',
      ],
    },
    primaryAction: {
      label: '新規お知らせを作成',
      href: '/admin/content/news/new',
    },
    rows: adminNewsRows,
  },
  '/admin/content/news/new': {
    header: {
      title: 'お知らせ新規作成',
      paragraphs: [
        '新しいお知らせを作成します。メール配信予定日時を指定して保存します。',
      ],
    },
    form: {
      labels: {
        title: 'お知らせタイトル',
        slug: 'slug',
        isPublished: '公開する',
        notificationScheduledAt: '配信予定日時',
        excerpt: '抜粋',
        body: '本文',
      },
      showPublishedAtField: false,
      defaults: {
        title: '',
        slug: '',
        isPublished: false,
        notify_on_publish: true,
        notificationScheduledAt: '',
        excerpt: '',
        body: '',
      },
      errors: {
        required: 'この項目は必須です。',
        invalidSlug: 'slugは半角英数字、ハイフン、アンダースコアで入力してください。日本語は使えません。',
      },
      slugHelpText: '任意項目です。公開URLの末尾に使われます。半角英数字、ハイフン、アンダースコアのみ入力できます。日本語は使えません。大文字は保存時に小文字化されます。空欄のまま保存するとタイトルから自動生成されます。slugは作成後に編集できません。',
      notificationScheduledAtHelpText: '必須項目です。未来日時なら予約配信、現在以前なら保存後に送信処理へ渡されます。実配信状態は通知履歴で確認してください。',
      excerptMaxLength: 255,
      excerptHelpText: '一覧・関連記事・SEO descriptionなどで短く表示する文章です。255文字以内で入力してください。',
      bodyHelpText: '公開お知らせ詳細の本文です。SEO descriptionには直接使われません。段落を分ける場合は空行で区切ってください。',
      submitLabel: 'お知らせを保存',
      pendingMessage: '保存しています。画像の登録に時間がかかる場合があります。',
    },
  },
  '/admin/content/news/:newsId/edit': {
    header: {
      title: 'お知らせ編集',
      paragraphs: [
        'お知らせの内容と公開状態を編集します。',
      ],
    },
    form: {
      labels: {
        title: 'お知らせタイトル',
        slug: 'slug',
        isPublished: '公開する',
        notificationScheduledAt: '配信予定日時',
        excerpt: '抜粋',
        body: '本文',
      },
      showPublishedAtField: false,
      errors: {
        required: 'この項目は必須です。',
        invalidSlug: 'slugは半角英数字、ハイフン、アンダースコアで入力してください。日本語は使えません。',
      },
      slugReadOnlyHelpText: 'slugは作成時のみ設定できます。公開URLとSEOの安定性を守るため、編集画面では変更できません。',
      notificationScheduledAtHelpText: '必須項目です。未来日時なら予約配信、現在以前なら保存後に送信処理へ渡されます。実配信状態は通知履歴で確認してください。',
      excerptMaxLength: 255,
      excerptHelpText: '一覧・関連記事・SEO descriptionなどで短く表示する文章です。255文字以内で入力してください。',
      bodyHelpText: '公開お知らせ詳細の本文です。SEO descriptionには直接使われません。段落を分ける場合は空行で区切ってください。',
      submitLabel: '変更を保存',
      pendingMessage: '保存しています。画像の登録に時間がかかる場合があります。',
    },
    recordsById: adminNewsDetailRecords,
  },
  '/admin/content/page-contents': {
    header: {
      title: 'ページコンテンツ管理',
      paragraphs: [
        '公開ページに表示するページコンテンツの画像や表示状態を管理します。',
        'ここでは既に定義済みの表示枠だけを編集します。新規登録は行いません。',
      ],
    },
  },
  '/admin/content/page-contents/:pageKey/:slotKey/edit': {
    header: {
      title: 'ページコンテンツ編集',
      paragraphs: [
        'ページコンテンツの公開状態と画像を編集します。',
      ],
    },
    form: {
      labels: {
        isPublished: '公開する',
        primaryImage: '画像',
      },
      mediaAssetField: createPrimaryImageField('reviews'),
      errors: {
        required: 'この項目は必須です。',
      },
      submitLabel: '変更を保存',
      pendingMessage: '保存しています。画像の登録に時間がかかる場合があります。',
    },
  },
  '/admin/content/reviews': {
    header: {
      title: '受講者の声管理',
      paragraphs: [
        '公開ページに掲載するレビューの内容、表示順、公開状態を管理します。',
      ],
    },
    primaryAction: {
      label: '新規レビューを作成',
      href: '/admin/content/reviews/new',
    },
    rows: adminReviewRows,
  },
  '/admin/content/reviews/new': {
    header: {
      title: '受講者の声新規作成',
      paragraphs: [
        '新しいレビューを作成します。表示順と公開状態を確認してください。',
      ],
    },
    form: {
      labels: {
        title: 'レビュータイトル',
        reviewerName: '氏名',
        reviewerTitle: '肩書き',
        reviewerUrl: 'レビュアーURL',
        displayOrder: '表示順',
        isPublished: '公開する',
        body: '本文',
      },
      defaults: {
        title: '',
        reviewerName: '',
        reviewerTitle: '',
        reviewerUrl: '',
        displayOrder: 1,
        isPublished: false,
        body: '',
      },
      errors: {
        required: 'この項目は必須です。',
        invalidUrl: 'URLは https:// から入力してください。',
      },
      displayOrderHelpText: '数字が小さいレビューほど先に表示されます。',
      reviewerUrlHelpText: '会社・団体・プロフィール等のURLがある場合のみ入力してください。公開面ではレビュアー氏名がこのURLへのリンクになります。https:// から始まるURLのみ指定できます。',
      submitLabel: 'レビューを保存',
      pendingMessage: '保存しています。',
    },
  },
  '/admin/content/reviews/:reviewId/edit': {
    header: {
      title: '受講者の声編集',
      paragraphs: [
        'レビューの内容、表示順、公開状態を編集します。',
      ],
    },
    form: {
      labels: {
        title: 'レビュータイトル',
        reviewerName: '氏名',
        reviewerTitle: '肩書き',
        reviewerUrl: 'レビュアーURL',
        displayOrder: '表示順',
        isPublished: '公開する',
        body: '本文',
      },
      errors: {
        required: 'この項目は必須です。',
        invalidUrl: 'URLは https:// から入力してください。',
      },
      displayOrderHelpText: '数字が小さいレビューほど先に表示されます。',
      reviewerUrlHelpText: '会社・団体・プロフィール等のURLがある場合のみ入力してください。公開面ではレビュアー氏名がこのURLへのリンクになります。https:// から始まるURLのみ指定できます。',
      submitLabel: '変更を保存',
      pendingMessage: '保存しています。',
    },
    recordsById: adminReviewDetailRecords,
  },
  '/admin/content/founder': {
    header: {
      title: '創始者管理',
      paragraphs: [
        '現在、公開ページでは表示できるコンテンツが限られています。新規登録する場合は、既存の1位または2位のコンテンツを非公開にした上で、新規登録コンテンツの表示順位を1位または2位に設定してください。',
      ],
    },
    primaryAction: {
      label: '新規コンテンツを作成',
      href: '/admin/content/founder/new',
    },
    rows: adminFounderCassetteRows,
  },
  '/admin/content/founder/new': {
    header: {
      title: '創始者コンテンツ新規作成',
      paragraphs: [
        '創始者ページに表示するコンテンツを作成します。',
      ],
    },
    form: {
      labels: {
        title: 'コンテンツタイトル',
        displayOrder: '表示順',
        isPublished: '公開する',
        body: '本文',
        primaryImage: '画像',
      },
      mediaAssetField: createPrimaryImageField('founder'),
      defaults: {
        title: '',
        displayOrder: adminFounderCassetteRows.length + 1,
        isPublished: false,
        body: '',
        primary_image_id: '',
      },
      errors: {
        required: 'この項目は必須です。',
      },
      displayOrderHelpText: '現在の公開ページでは、表示順1位・2位のコンテンツのみ表示されます。',
      submitLabel: 'コンテンツを保存',
      pendingMessage: '保存しています。画像の登録に時間がかかる場合があります。',
    },
  },
  '/admin/content/founder/:cassetteId/edit': {
    header: {
      title: '創始者コンテンツ編集',
      paragraphs: [
        '創始者ページに表示するコンテンツの内容、表示順、公開状態を編集します。',
      ],
    },
    form: {
      labels: {
        title: 'コンテンツタイトル',
        displayOrder: '表示順',
        isPublished: '公開する',
        body: '本文',
        primaryImage: '画像',
      },
      mediaAssetField: createPrimaryImageField('founder'),
      errors: {
        required: 'この項目は必須です。',
      },
      displayOrderHelpText: '現在の公開ページでは、表示順1位・2位のコンテンツのみ表示されます。',
      submitLabel: '変更を保存',
      pendingMessage: '保存しています。画像の登録に時間がかかる場合があります。',
    },
    recordsById: adminFounderCassetteRecords,
  },
  '/admin/members': {
    header: {
      title: '会員管理',
      paragraphs: [
        '会員の基本情報、会員資格、プロフィール、アカウント状態を確認します。会員資格や管理権限は関連リンクから確認してください。',
      ],
    },
    relatedLinks: [
      { label: '会員資格一覧', href: '/admin/access/member' },
      { label: '管理権限一覧', href: '/admin/access/operator' },
      { label: '管理者一覧', href: '/admin/operators' },
    ],
    filters: {
      lifecycleStatus: [
        { value: '', label: 'すべて' },
        { value: 'active', label: '有効' },
        { value: 'suspended', label: '停止中' },
        { value: 'withdrawn', label: '退会' },
      ],
    },
    primaryAction: {
      label: '新規会員を作成',
      href: '/admin/members/new',
    },
    rows: adminMemberRows,
  },
  '/admin/applicants': {
    header: {
      title: '問い合わせ・申込者管理',
      paragraphs: [
        '問い合わせ・申込など、外部からの接点を確認します。必要に応じて、会員登録フォームの送付や関連内容の確認を行います。',
      ],
    },
    relatedLinks: [
      { label: '会員一覧', href: '/admin/members' },
    ],
    filters: {
      applicantType: [
        { value: '', label: 'すべて' },
        { value: 'inquiry', label: '問合せ' },
        { value: 'application', label: '申込' },
      ],
      activeStatus: [
        { value: '', label: 'すべて' },
        { value: 'true', label: '管理中' },
        { value: 'false', label: '停止中' },
      ],
    },
    rows: [],
  },
  '/admin/applicants/:applicantId': {
    header: {
      title: '問い合わせ・申込者詳細',
      paragraphs: [
        '問い合わせ・申込の内容と、会員登録フォームの送信状態を確認します。',
      ],
    },
    relatedLinks: [
      { label: '問い合わせ・申込者一覧', href: '/admin/applicants' },
      { label: '会員一覧', href: '/admin/members' },
    ],
    labels: {
      id: '問い合わせ・申込者ID',
      name: '氏名',
      nameKana: 'ふりがな',
      email: 'メールアドレス',
      phone: '電話番号',
      type: '問合せ/申込',
      source: '関連元',
      sourceKind: '関連元種別',
      memberLink: '会員連携',
      managementStatus: '管理状態',
      invitationStatus: '送信状態',
      memberRegistration: '会員登録フォーム',
      invitationSentAt: 'フォーム送信日時',
      createdAt: '作成日',
      updatedAt: '更新日',
      message: '問い合わせ内容',
    },
    actions: {
      title: '会員登録フォーム',
      paragraphs: [
        'この問い合わせ・申込者を会員登録へ進めるため、本人へ会員登録フォームを送信します。',
      ],
      sendInvitationLabel: '会員登録フォームを送信',
      sendingLabel: '送信中...',
      sendingMessage: '会員登録フォームを送信しています。',
      sentMessage: '会員登録フォームを送信しました。',
      sendErrorMessage: '会員登録フォームを送信できませんでした。状態を確認してください。',
      unavailableMessage: 'この問い合わせ・申込者には会員登録フォームを送信できません。',
    },
    loadErrorMessage: '問い合わせ・申込者を読み込めませんでした。',
    notFoundMessage: '指定された問い合わせ・申込者は見つかりませんでした。',
  },
  '/admin/operators': {
    header: {
      title: '管理者管理',
      paragraphs: [
        '管理画面を操作する人物プロフィールを確認・編集します。管理権限の有効/停止は管理権限で扱います。',
      ],
    },
    relatedLinks: [
      { label: '管理権限一覧', href: '/admin/access/operator' },
      { label: '会員一覧', href: '/admin/members' },
    ],
  },
  '/admin/operators/:accessId/edit': {
    header: {
      title: '管理者編集',
      paragraphs: [
        '管理者の人物プロフィールを編集します。管理権限の有効/停止は管理権限で操作します。',
      ],
    },
    relatedLinks: [
      { label: '管理者一覧', href: '/admin/operators' },
      { label: '管理権限一覧', href: '/admin/access/operator' },
      { label: '会員一覧', href: '/admin/members' },
    ],
    form: {
      labels: {
        name: '氏名',
        nameKana: 'ふりがな',
        email: 'メールアドレス',
        phone: '電話番号',
        postalCode: '郵便番号',
        address: '住所',
        note: '備考',
      },
      errors: {
        required: 'この項目は必須です。',
      },
      submitLabel: '変更を保存',
      pendingMessage: '保存しています。',
      successMessage: '管理者プロフィールを更新しました。',
      loadErrorMessage: '管理者を読み込めませんでした。',
      errorMessage: '管理者プロフィールを更新できませんでした。入力内容を確認してください。',
      profileMissingMessage: 'この管理者には人物プロフィールがありません。氏名とメールアドレスを入力してプロフィールを作成してください。',
      emailHelpText: 'ここで変更するメールアドレスは人物プロフィール用です。ログインIDは変更されません。',
    },
  },
  '/admin/members/new': {
    header: {
      title: '会員新規作成',
      paragraphs: [
        '新しい会員情報を登録します。',
      ],
    },
    form: {
      labels: {
        name: '氏名',
        nameKana: 'ふりがな',
        email: 'メールアドレス',
        sendPasswordSetup: '本人へ初回設定依頼を送る',
        lifecycleStatus: '会員資格',
        phone: '電話番号',
        postalCode: '郵便番号',
        address: '住所',
        note: '備考',
      },
      defaults: {
        name: '',
        nameKana: '',
        email: '',
        sendPasswordSetup: true,
        lifecycleStatus: 'active',
        phone: '',
        postalCode: '',
        address: '',
        note: '',
      },
      errors: {
        required: 'この項目は必須です。',
      },
      options: {
        lifecycleStatus: [
          { value: 'active', label: '有効' },
          { value: 'suspended', label: '停止中' },
          { value: 'withdrawn', label: '退会' },
        ],
      },
      lifecycleStatusHelpText: '会員資格の分類です。有効の場合は会員資格が有効化され、停止中・退会の場合は会員資格が停止されます。',
      sendPasswordSetupHelpText: '会員作成後、本人が初回パスワードを設定するための依頼を送ります。',
      submitLabel: '会員を保存',
      pendingMessage: '保存しています。',
      successMessage: '会員を作成しました。',
      duplicateEmailMessage: 'このメールアドレスはすでに使用されています。',
      duplicateEnsureMembershipMessage: 'このメールアドレスは既存アカウントとして登録されています。必要に応じて、既存アカウントへ会員資格を付与できます。',
      ensureMembershipTitle: '既存アカウントへ会員資格を付与',
      ensureMembershipLead: '主催者・講師・関係者などとして登録済みのログインアカウントに、会員プロフィールと会員資格を追加します。',
      ensureMembershipEmailLabel: 'ログインメールアドレス',
      ensureMembershipProfileLabel: '会員プロフィール',
      ensureMembershipAccessLabel: '会員資格',
      ensureMembershipActionLabel: '会員資格を付与',
      ensureMembershipPendingMessage: '会員資格を付与しています。',
      ensureMembershipSuccessMessage: '会員資格を付与しました。',
      ensureMembershipErrorMessage: '会員資格を付与できませんでした。対象アカウントの状態を確認してください。',
      errorMessage: '会員を作成できませんでした。入力内容を確認してください。',
    },
  },
  '/admin/members/:memberId/edit': {
    header: {
      title: '会員編集',
      paragraphs: [
        '会員の基本情報、プロフィールの有効性、会員資格を編集します。会員資格や管理権限は関連リンクから確認してください。',
      ],
    },
    form: {
      labels: {
        name: '氏名',
        nameKana: 'ふりがな',
        email: 'メールアドレス',
        isActive: 'プロフィールを有効にする',
        lifecycleStatus: '会員資格',
        phone: '電話番号',
        postalCode: '郵便番号',
        address: '住所',
        note: '備考',
      },
      errors: {
        required: 'この項目は必須です。',
      },
      options: {
        lifecycleStatus: [
          { value: 'active', label: '有効' },
          { value: 'suspended', label: '停止中' },
          { value: 'withdrawn', label: '退会' },
        ],
      },
      isActiveHelpText: 'プロフィールレコード自体を通常運用対象として扱う場合に有効にします。会員資格の有効/停止とは別概念です。',
      lifecycleStatusHelpText: '会員資格の分類です。有効の場合は会員資格が有効化され、停止中・退会の場合は会員資格が停止されます。',
      submitLabel: '変更を保存',
      pendingMessage: '保存しています。',
      successMessage: '会員を更新しました。',
      loadErrorMessage: '会員情報を読み込めませんでした。',
      errorMessage: '会員を更新できませんでした。入力内容を確認してください。',
    },
    recordsById: adminMemberDetailRecords,
  },
  '/admin/access/member': {
    header: {
      title: '会員資格管理',
      paragraphs: [
        '会員として利用できる状態かを確認・変更します。',
      ],
    },
    relatedLinks: [
      { label: '会員一覧', href: '/admin/members' },
      { label: '管理権限一覧', href: '/admin/access/operator' },
      { label: '主催者一覧', href: '/admin/events/organizers' },
    ],
    primaryAction: {
      label: '会員資格を作成',
      href: '/admin/access/member/new',
    },
    filters: {
      isActive: [
        { value: '', label: 'すべて' },
        { value: 'true', label: '有効' },
        { value: 'false', label: '停止中' },
      ],
    },
  },
  '/admin/access/member/new': {
    header: {
      title: '会員資格新規作成',
      paragraphs: [
        '対象アカウントに会員資格を割り当てます。',
      ],
    },
    relatedLinks: [
      { label: '会員一覧', href: '/admin/members' },
      { label: '管理権限一覧', href: '/admin/access/operator' },
      { label: '主催者一覧', href: '/admin/events/organizers' },
    ],
    form: {
      labels: {
        memberId: '対象会員',
        isActive: '有効にする',
      },
      memberOptions: [{ value: '', label: '対象会員を選択' }],
      accessBindings: [],
      defaults: {
        memberId: '',
        isActive: true,
      },
      errors: {
        required: 'この項目は必須です。',
      },
      isActiveHelpText: '無効にすると通常の運用対象から外します。',
      submitLabel: '会員アクセスを保存',
      pendingMessage: '保存しています。',
      successMessage: '会員資格を作成しました。',
      duplicateMessage: 'この会員にはすでに会員資格があります。',
      loadErrorMessage: '会員候補を読み込めませんでした。',
      errorMessage: '会員資格を作成できませんでした。入力内容を確認してください。',
    },
  },
  '/admin/access/member/:accessId/edit': {
    header: {
      title: '会員資格編集',
      paragraphs: [
        '会員資格の内容と有効状態を編集します。',
      ],
    },
    relatedLinks: [
      { label: '会員一覧', href: '/admin/members' },
      { label: '管理権限一覧', href: '/admin/access/operator' },
      { label: '主催者一覧', href: '/admin/events/organizers' },
    ],
    form: {
      labels: {
        memberId: '対象会員',
        isActive: '有効にする',
      },
      memberOptions: [{ value: '', label: '対象会員を選択' }],
      accessBindings: [],
      errors: {
        required: 'この項目は必須です。',
      },
      isActiveHelpText: '無効にすると通常の運用対象から外します。',
      submitLabel: '変更を保存',
      pendingMessage: '保存しています。',
      successMessage: '会員資格を更新しました。',
      loadErrorMessage: '会員資格を読み込めませんでした。',
      errorMessage: '会員資格を更新できませんでした。入力内容を確認してください。',
    },
  },
  '/admin/access/operator': {
    header: {
      title: '管理権限管理',
      paragraphs: [
        '管理画面を操作できる権限の状態を管理します。人物プロフィールは管理者で編集します。',
      ],
    },
    relatedLinks: [
      { label: '管理者一覧', href: '/admin/operators' },
      { label: '会員資格一覧', href: '/admin/access/member' },
      { label: '会員一覧', href: '/admin/members' },
    ],
    primaryAction: {
      label: '新規管理権限を作成',
      href: '/admin/access/operator/new',
    },
    rows: [],
    filters: {
      isActive: [
        { value: '', label: 'すべて' },
        { value: 'true', label: '有効' },
        { value: 'false', label: '停止中' },
      ],
    },
  },
  '/admin/access/operator/new': {
    header: {
      title: '管理権限新規作成',
      paragraphs: [
        '対象アカウントに管理権限を割り当てます。',
      ],
    },
    relatedLinks: [
      { label: '管理者一覧', href: '/admin/operators' },
      { label: '会員資格一覧', href: '/admin/access/member' },
      { label: '会員一覧', href: '/admin/members' },
    ],
    form: {
      labels: {
        memberId: '対象会員',
        isActive: '有効にする',
      },
      memberOptions: adminAccessMemberOptions,
      accessBindings: [
        {
          name: 'operatorRoles',
          label: '管理者権限',
          type: 'checkbox-group',
          options: [
            { value: 'admin', label: '管理者' },
          ],
          helpText:
            '現状は管理者権限のみを扱います。',
        },
      ],
      defaults: {
        memberId: '',
        operatorRoles: [],
        isActive: false,
      },
      errors: {
        required: 'この項目は必須です。',
        selectAtLeastOne: '少なくとも1つ選択してください。',
      },
      isActiveHelpText: '無効にすると通常の運用対象から外します。',
      submitLabel: '管理権限を保存',
      pendingMessage: '保存しています。',
      successMessage: '管理権限を作成しました。',
      duplicateMessage: 'この会員にはすでに管理権限があります。',
      loadErrorMessage: '会員候補を読み込めませんでした。',
      errorMessage: '管理権限を作成できませんでした。入力内容を確認してください。',
    },
  },
  '/admin/access/operator/:accessId/edit': {
    header: {
      title: '管理権限編集',
      paragraphs: [
        '管理権限と有効状態を編集します。人物プロフィールは管理者で編集します。',
      ],
    },
    relatedLinks: [
      { label: '管理者一覧', href: '/admin/operators' },
      { label: '会員資格一覧', href: '/admin/access/member' },
      { label: '会員一覧', href: '/admin/members' },
    ],
    form: {
      labels: {
        operator: '対象管理者',
        isActive: '有効にする',
      },
      accessBindings: [
        {
          name: 'operatorRoles',
          label: '管理者権限',
          type: 'checkbox-group',
          options: [
            { value: 'admin', label: '管理者' },
          ],
          helpText:
            '現状は管理者権限のみを扱います。',
        },
      ],
      errors: {
        required: 'この項目は必須です。',
        selectAtLeastOne: '少なくとも1つ選択してください。',
      },
      isActiveHelpText: '無効にすると管理画面へアクセスできません。',
      mailSenderIdentity: {
        title: 'メール送信元',
        lead:
          'この管理者がメール画面から送信する際に選択できる個人送信元を設定します。送信画面で送信元を自由入力することはできません。',
        labels: {
          label: '表示ラベル',
          displayName: '差出人名',
          email: '送信元メールアドレス（@より前）',
          replyToEmail: '返信先メールアドレス（@より前）',
          isActive: '送信元として使用する',
          isDefault: '既定の送信元にする',
        },
        allowedSenderDomainsLabel: '送信元で使用できるドメイン',
        allowedReplyToDomainsLabel: '返信先で使用できるドメイン',
        emailHelpText: '送信元メールアドレスの@より前を入力します。ドメインは許可された送信ドメインから自動で組み合わせます。',
        replyToHelpText: '返信を受け取るアドレスの@より前を入力します。返信を受けるには、受信用に設定済みのドメインを選択してください。',
        submitLabel: 'メール送信元を保存',
        pendingMessage: 'メール送信元を保存しています。',
        successMessage: 'メール送信元を保存しました。',
        loadErrorMessage: 'メール送信元を読み込めませんでした。',
        errorMessage: 'メール送信元を保存できませんでした。入力内容と許可ドメインを確認してください。',
      },
      submitLabel: '変更を保存',
      pendingMessage: '保存しています。',
      successMessage: '管理権限を更新しました。',
      loadErrorMessage: '管理権限を読み込めませんでした。',
      errorMessage: '管理権限を更新できませんでした。入力内容を確認してください。',
    },
  },
}, blogDetailPages);

module.exports = supportPageContent;
module.exports.supportPageContent = supportPageContent;
